<template>
    <v-container no-wrap class="pa-0" style="max-width:99%;margin-left:0%;">
        <v-row>
            <v-col :style="'max-width:' + (pdfOpen ? '40%' : '2%')" class="pr-1 pt-0">
                <v-row no-gutters>
                    <v-col :style="'max-width:' + (pdfOpen ? '97%' : '0%')" v-show="pdfOpen">
                        <v-card elevation="0">
                            <!-- <iframe :key="$store.getters.encPDF" :src="$store.getters.encPDF" width="100%" :height="$root.vh" /> -->
                            <!-- <PDFJSViewer :docURL="encPDF" /> -->

                            <!-- <SimplePDFViewer :docURL="encPDF" :key="encPDF" :height="$root.vh" /> -->
                            <EnhancedDocViewer :proMode="proMode" :facility="facility" :client="client" :docs="activeDocs" :key="activeDocs[0].dockey" :height="$root.vh" />
                        </v-card>
                    </v-col>
                    <v-col :style="'max-width:' + (pdfOpen ? '3%' : '100%')">
                        <v-btn 
                            :color="proMode ?  'grey darken-1' : 'grey-darken-4'"
                            :dark="proMode"
                            icon
                            block
                            :style="'max-width:100%;border-radius:0;height:' + $root.vh"
                            @click="togglePDF"
                        >
                            <v-icon v-if="pdfOpen">mdi-chevron-left</v-icon>
                            <v-icon v-else>mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col :style="'max-width:' + (pdfOpen ? '60%' : '98%')" class="pt-0">
                <v-row v-if="!splitView">
                    <v-col class="pa-0 ma-0" :style="'max-width:' + (!pdfOpen ? '99%' : '100%')">
                        <v-card :dark="proMode" style="width:100%;" elevation="1" height="275">
                            <v-card-title>
                                <v-col cols="4">
                                    <v-select
                                        class="demofields25"
                                        dense
                                        label="Filter by Status"
                                        v-model="sortStatus"
                                        outlined
                                        :items=sortStatuses
                                    ></v-select>
                                </v-col>
                                <v-col cols="8">
                                    <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-card-title>
                            <v-data-table
                                dense
                                :key="wsUps"
                                :headers="codeListHeaders"
                                :items="encs[facility]"
                                :search="search"
                                sort-by="dos"
                                :sort-desc="false"
                                item-key="encid"
                                height="175"
                                fixed-header
                                :items-per-page="10"
                                class="enctable"
                            >
                                <template v-slot:item.demographics.lastName="{ item }">
                                    {{item.demographics.lastName + ", " + item.demographics.firstName}}
                                </template>
                                <template v-slot:item.buttons="{ item }">
                                    <v-row no-gutters>
                                        <v-col cols="4">
                                            <v-btn
                                                :color="proMode ? 'white' : 'black'"
                                                small
                                                text
                                                class="px-0"
                                                @click="openNotesEncList(item)"
                                            >
                                                <v-icon small>mdi-note-text</v-icon> {{(item.notes.length > 0 ? "(" + item.notes.length + ")" : "")}}
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-btn
                                                :color="proMode ? 'white' : 'black'"
                                                small
                                                text
                                                class="px-0"
                                                @click="openRow(item,true)"
                                            >
                                                <v-icon small>mdi-eye-outline</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-btn
                                                :color="proMode ? 'white' : 'black'"
                                                small
                                                text
                                                class="px-0"
                                                :disabled="item.status == 'EXPORT'"
                                                @click="openRow(item,false)"
                                            >
                                                <v-icon small>mdi-pencil</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </template>
                                <!-- <template v-slot:item.noteButton="{ item }">
                                    <v-btn
                                        :color="proMode ? 'white' : 'black'"
                                        small
                                        text
                                        class="px-0"
                                        @click="openNotesEncList(item)"
                                    >
                                        <v-icon small>mdi-note-text</v-icon> {{(item.notes.length > 0 ? "(" + item.notes.length + ")" : "")}}
                                    </v-btn>
                                </template>
                                <template v-slot:item.viewButton="{ item }">
                                    <v-btn
                                        :color="proMode ? 'white' : 'black'"
                                        small
                                        text
                                        class="px-0"
                                        @click="openRow(item,true)"
                                    >
                                        <v-icon small>mdi-eye-outline</v-icon>
                                    </v-btn>
                                </template>
                                <template v-slot:item.loadButton="{ item }">
                                    <v-btn
                                        :color="proMode ? 'white' : 'black'"
                                        small
                                        text
                                        class="px-0"
                                        @click="openRow(item,false)"
                                    >
                                        <v-icon small>mdi-pencil</v-icon>
                                    </v-btn>
                                </template> -->
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col :style="'max-width:' + (!pdfOpen ? '1%' : '0%')" v-show="!pdfOpen" class="pa-0 ma-0">
                        <v-btn 
                            :color="proMode ?  'grey darken-1' : 'grey-darken-4'"
                            icon
                            block
                            style="max-width:100%;border-radius:0;height:275px"
                            @click="toggleSplitView"
                        >
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-if="splitView" cols="5" class="pa-0 ma-0">
                        <v-row no-gutters>
                            <v-col class="pa-0 ma-0" style="max-width:97%">
                                <v-card :dark="proMode" style="width:100%;" elevation="1" :height="$root.vh">
                                    <v-card-title>
                                        <v-col cols="4">
                                            <v-select
                                                class="demofields25"
                                                dense
                                                label="Filter by Status"
                                                v-model="sortStatus"
                                                outlined
                                                :items=sortStatuses
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="8">
                                            <v-text-field
                                                v-model="search"
                                                append-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                    </v-card-title>
                                    <v-data-table
                                        dense
                                        :key="wsUps"
                                        :headers="codeListHeadersSplit"
                                        sort-by="dos"
                                        :sort-desc="false"
                                        :items="encs[facility]"
                                        :search="search"
                                        item-key="encid"
                                        :height="svTableHeight"
                                        fixed-header
                                        :items-per-page="25"
                                        class="enctable"
                                    >
                                        <template v-slot:item.demographics.lastName="{ item }">
                                            {{item.demographics.lastName + ", " + item.demographics.firstName}}
                                        </template>
                                        <template v-slot:item.buttons="{ item }">
                                            <v-row no-gutters>
                                                <v-col cols="4">
                                                    <v-btn
                                                        :color="proMode ? 'white' : 'black'"
                                                        small
                                                        text
                                                        class="px-0"
                                                        @click="openNotesEncList(item)"
                                                    >
                                                        <v-icon small>mdi-note-text</v-icon> {{(item.notes.length > 0 ? "(" + item.notes.length + ")" : "")}}
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-btn
                                                        :color="proMode ? 'white' : 'black'"
                                                        small
                                                        text
                                                        class="px-0"
                                                        @click="openRow(item,true)"
                                                    >
                                                        <v-icon small>mdi-eye-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-btn
                                                        :color="proMode ? 'white' : 'black'"
                                                        small
                                                        text
                                                        class="px-0"
                                                        :disabled="item.status == 'EXPORT'"
                                                        @click="openRow(item,false)"
                                                    >
                                                        <v-icon small>mdi-pencil</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-col>
                            <v-col style="max-width:3%" class="pa-0 ma-0">
                                <v-btn 
                                    :color="proMode ?  'grey darken-1' : 'grey-darken-4'"
                                    icon
                                    block
                                    :style="'max-width:100%;border-radius:0;height:' + $root.vh"
                                    @click="toggleSplitView"
                                >
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col :cols="(splitView ? 7 : 12)" class="pa-0 ma-0">
                        <v-card :dark="proMode" class="mt-0" style="width:100%;border-top:1px solid slategrey;border-radius:0;overflow:hidden;" :height="(splitView ? rowHeight+275 : rowHeight)" elevation="1">
                            <v-card-title v-if="activeEnc.encid && !noteListDialog" :class="proMode ? '' : 'lighterBground'" style="border-bottom:1px solid darkslategrey;border-radius:0;font-size:16px">
                                {{
                                    activeEnc.demographics.mrn + " | " + 
                                    activeEnc.demographics.lastName + ", " + activeEnc.demographics.firstName + " - " +
                                    activeEnc.dos
                                }}
                                <v-spacer></v-spacer>
                                <span :style="'font-style:italic;color:' + (proMode ? 'yellow' : 'red')" v-if="readonly">*** READ ONLY ***</span>
                                <span class="ml-2" v-if="qaEnc">Reviewing: {{(activeQaEnc.qa_user ? activeQaEnc.qa_user : activeQaEnc.lastModifiedUser)}} {{(activeEnc.qa_diff ? ' - ✗' : ' - ✓' )}}</span>
                                <v-spacer></v-spacer>
                                {{ activeEnc.status }} <span class="mr-1" v-if="activeEnc.status == 'EXPORT'">: {{new Date((activeEnc.export_time ? activeEnc.export_time*1000 : activeEnc.lastModifiedDate)).toLocaleDateString()}} |</span>
                                <v-btn
                                    :color="proMode ? 'white' : 'black'"
                                    small
                                    text
                                    class="px-0"
                                    @click="notesdialog=true"
                                >
                                    <v-icon small>mdi-note-text</v-icon> {{(activeEnc.notes.length > 0 ? "(" + activeEnc.notes.length + ")" : "")}}
                                </v-btn>
                            </v-card-title>
                            <v-card-title :class="proMode ? '' : 'lighterBground'" style="font-size:16px" v-else>
                                Encounter Data
                            </v-card-title>
                                <v-card-text :style="'padding-top:15px;overflow-x:hidden;overflow-y:scroll;height:'+ (splitView ? cardHeight + 275 : cardHeight) +'px'">
                                    <!-- Encounter-open failure. Rendered here rather than over the
                                         form because the failure policy is to hold no active
                                         encounter, so the form below does not render at all. -->
                                    <v-row no-gutters v-if="encLoadError && !noteListDialog" style="margin-bottom:10px;">
                                        <v-col cols="12">
                                            <div :class="'v-messages error--text ' + (proMode ? 'theme--dark' : 'theme--light')" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message">{{encLoadError}}</div></div></div>
                                            <v-btn
                                                :color="proMode ? 'white' : 'black'"
                                                small
                                                text
                                                class="px-0 mt-1"
                                                @click="retryEncounterLoad"
                                            >
                                                <v-icon small>mdi-refresh</v-icon> Retry
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-form :disabled="readonly" ref="encform" v-model="encValid" v-if="activeEnc.encid  && !noteListDialog">
                                        <v-row no-gutters style="height:60px;">
                                            <v-col cols="2">
                                                <v-text-field
                                                    class="demofields"
                                                    dense
                                                    label="FIN"
                                                    v-model="activeEnc.ext_id"
                                                    outlined
                                                    readonly
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-text-field
                                                class="demofields"
                                                    readonly
                                                    dense
                                                    label="Payer"
                                                    v-model="activeEnc.demographics.payer"
                                                    outlined
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="1">
                                                <v-text-field
                                                class="demofields"
                                                    readonly
                                                    dense
                                                    label="Sex"
                                                    v-model="activeEnc.demographics.gender"
                                                    outlined
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-text-field
                                                class="demofields"
                                                    readonly
                                                    dense
                                                    label="DOB"
                                                    v-model="activeEnc.demographics.dob"
                                                    outlined
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-select
                                                class="demofields"
                                                    dense
                                                    :label="(qaEnc ? 'DD: ' + activeQaEnc.discharge_disposition + (activeQaEnc.discharge_disposition == activeEnc.discharge_disposition ? ' - ✓' : ' - ✗' ) : 'Discharge Disposition')"
                                                    v-model="activeEnc.discharge_disposition"
                                                    outlined
                                                    :rules="fieldRule(activeEnc.discharge_disposition,'discharge_disposition')"
                                                    item-text="label"
                                                    item-value="value"
                                                    :items=$store.getters.facSettings.discharge_reasons
                                                ></v-select>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-menu
                                                    v-model="menuacc"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                    :disabled="readonly"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        class="demofields"
                                                        v-model="activeEnc.accident_date"
                                                        :label="(qaEnc ? 'AD: ' + activeQaEnc.accident_date + (activeQaEnc.accident_date == activeEnc.accident_date ? ' - ✓' : ' - ✗' ) : 'Accident Date')"
                                                        :rules="fieldRule(activeEnc.accident_date,'accident_date')"
                                                        dense
                                                        outlined
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        v-model="activeEnc.accident_date"
                                                        @input="menuacc = false"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                        <v-divider style="margin-top:-10px;margin-bottom:10px;"></v-divider>
                                        <v-row no-gutters v-if="$store.getters.facTools.indexOf('EM_TOOL_PRO_LT')!=-1">
                                            <v-col style="padding:0" cols="12">
                                                <v-row no-gutters style="height:45px;margin-top:5px;">
                                                    <v-col cols="3">
                                                        <v-select
                                                            class="demofields"
                                                            dense
                                                            outlined
                                                            :rules="fieldRule(emToolPro.history,'EM_0_history')"
                                                            v-model="emToolPro.history"
                                                            :items="emToolProLT.history"
                                                            :label="(qaEnc && activeQaEnc.codes.em[0] && activeQaEnc.codes.em[0].tool ? 'History: ' + activeQaEnc.codes.em[0].tool.history + (activeQaEnc.codes.em[0].tool.history == emToolPro.history ? ' - ✓' : ' - ✗' ) : 'History')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        ></v-select>
                                                    </v-col>
                                                    <v-col cols="3">
                                                        <v-select
                                                            class="demofields"
                                                            dense
                                                            outlined
                                                            :rules="fieldRule(emToolPro.exam,'EM_0_exam')"
                                                            v-model="emToolPro.exam"
                                                            :items="emToolProLT.exam"
                                                            :label="(qaEnc && activeQaEnc.codes.em[0] && activeQaEnc.codes.em[0].tool ? 'Exam: ' + activeQaEnc.codes.em[0].tool.exam + (activeQaEnc.codes.em[0].tool.exam == emToolPro.exam ? ' - ✓' : ' - ✗' ) : 'Exam')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        ></v-select>
                                                    </v-col>
                                                    <v-col cols="3">
                                                        <v-select
                                                            class="demofields"
                                                            dense
                                                            outlined
                                                            :rules="fieldRule(emToolPro.mdm,'EM_0_mdm')"
                                                            v-model="emToolPro.mdm"
                                                            :items="emToolProLT.mdm"
                                                            :label="(qaEnc && activeQaEnc.codes.em[0] && activeQaEnc.codes.em[0].tool ? 'MDM: ' + activeQaEnc.codes.em[0].tool.mdm + (activeQaEnc.codes.em[0].tool.mdm == emToolPro.mdm ? ' - ✓' : ' - ✗' ) : 'MDM')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        ></v-select>
                                                    </v-col>
                                                    <v-col cols="2">
                                                        <v-select
                                                            class="demofields"
                                                            dense
                                                            outlined
                                                            :rules="fieldRule(emToolPro.time,'EM_0_time')"
                                                            v-model="emToolPro.time"
                                                            :items="emToolProLT.time"
                                                            :label="(qaEnc && activeQaEnc.codes.em[0] && activeQaEnc.codes.em[0].tool ? 'Time: ' + activeQaEnc.codes.em[0].tool.time + (activeQaEnc.codes.em[0].tool.time == emToolPro.time ? ' - ✓' : ' - ✗' ) : 'Time')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        ></v-select>
                                                    </v-col>
                                                    <v-col cols="1">
                                                        <v-checkbox
                                                            style="margin:2px 5px;"
                                                            class="nextDay"
                                                            @click="toggleDowncode"
                                                            v-model="activeEnc.codes.em[0].downcode"
                                                            :rules="fieldRule(activeEnc.codes.em[0].downcode,'EM_downcode')"
                                                            :label="(qaEnc && activeQaEnc.codes.em[0].downcode ? 'DC: ' + activeQaEnc.codes.em[0].downcode + (activeQaEnc.codes.em[0].downcode == activeEnc.codes.em[0].downcode ? ' - ✓' : ' - ✗' ) : 'Down- code')"
                                                        ></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters v-if="acepToolEnabled">
                                            <v-col style="padding:0" cols="12">
                                                <!-- Worksheet request state. Deliberately not the picker's own
                                                     hint: Vuetify only shows a hint when the input has no other
                                                     message, so the EM_0_acep required-field rule would hide it
                                                     exactly when the worksheet failed to load. -->
                                                <v-row no-gutters v-if="$store.getters.acepToolMessage" style="margin-top:5px;">
                                                    <v-col cols="12">
                                                        <div :class="'v-messages theme--dark ' + ($store.getters.acepToolLoading ? '' : 'error--text')" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message">{{$store.getters.acepToolMessage}}</div></div></div>
                                                    </v-col>
                                                </v-row>
                                                <v-row no-gutters style="margin-top:5px;">
                                                    <v-col cols="12">
                                                        <v-autocomplete
                                                            class="demofields"
                                                            dense
                                                            outlined
                                                            :rules="fieldRule(emToolACEP[0],'EM_0_acep')"
                                                            v-model="emToolACEP"
                                                            :items="acepPickerItems"
                                                            :loading="$store.getters.acepToolLoading"
                                                            :disabled="!$store.getters.acepToolSelectable"
                                                            :no-data-text="acepPickerNoDataText"
                                                            item-text="description"
                                                            :item-value="acepItemValue"
                                                            small-chips
                                                            deletable-chips
                                                            return-object
                                                            height="75px"
                                                            multiple
                                                            :label="acepPickerLabel(activeQaEnc,emToolACEP)"
                                                            :class="(qaEnc ? 'activeLabelOver acfix' : 'acfix')"
                                                        >
                                                            <template v-slot:item="{ active, item, attrs, on }">
                                                                <!-- <template v-if="typeof data.item !== 'object'">
                                                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                                                </template> -->
                                                                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                                                    <v-list-item-action>
                                                                        <v-checkbox :input-value="active"></v-checkbox>
                                                                    </v-list-item-action>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{item.level}} - {{item.description}}</v-list-item-title>
                                                                        <!-- Sanitized: this is service-authored HTML. -->
                                                                        <v-list-item-subtitle v-if="item.additional_info" v-html="acepAdditionalInfo(item)"></v-list-item-subtitle>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </template>                                                            
                                                        </v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                                <v-row no-gutters style="height:75px;margin-top:25px;">
                                                    <v-col cols="12">
                                                        <v-textarea
                                                            class="demofields"
                                                            dense
                                                            rows="2"
                                                            outlined
                                                            label="Tool Note"
                                                            v-model="activeEnc.codes.em[0].tool.note"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        ></v-textarea>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <div v-if="activeEnc.codes.em[0].downcode">
                                            <div v-for="(dc,dcind) in activeEnc.downcodes" :key="activeEnc.encid + '_dc_' + dcind">
                                                <v-row no-gutters>
                                                    <v-col style="padding:0" cols="11">
                                                        <v-row no-gutters style="height:60px;margin-top:5px;">
                                                            <v-col cols="1">
                                                                <v-text-field
                                                                    class="demofields"
                                                                    style="font-size:14px;font-weight:bold;"
                                                                    dense
                                                                    label="Type"
                                                                    outlined
                                                                    value="DC"
                                                                    readonly
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="3">
                                                                <v-select
                                                                class="demofields"
                                                                    dense
                                                                    :label="(qaEnc && activeQaEnc.downcodes[dcind] ? 'Area: ' + activeQaEnc.downcodes[dcind].area + (activeQaEnc.downcodes[dcind].area == dc.area? ' - ✓' : ' - ✗' ) : 'Area')"
                                                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                    v-model="dc.area"
                                                                    outlined
                                                                    :items=$store.getters.downcodeReasons
                                                                ></v-select>
                                                            </v-col>
                                                            <v-col cols="1">
                                                                <v-text-field
                                                                    class="demofields"
                                                                    dense
                                                                    :label="(qaEnc && activeQaEnc.downcodes[dcind] ? 'Q: ' + activeQaEnc.downcodes[dcind].qty + (activeQaEnc.downcodes[dcind].qty == dc.qty? ' - ✓' : ' - ✗' ) : 'Qty')"
                                                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                    type="number"
                                                                    min="1"
                                                                    v-model="dc.qty"
                                                                    outlined
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="3">
                                                                <v-combobox
                                                                    class="demofields"
                                                                    dense
                                                                    :label="(qaEnc && activeQaEnc.downcodes[dcind] ? 'Nurse: ' + activeQaEnc.downcodes[dcind].nurse + (activeQaEnc.downcodes[dcind].nurse == dc.nurse? ' - ✓' : ' - ✗' ) : 'Nurse')"
                                                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                    v-model="dc.nurse"
                                                                    @input="dc.nurse = objToValue(dc.nurse,'displayName')"
                                                                    outlined
                                                                    item-text="displayName"
                                                                    item-value="displayName"
                                                                    :items=$store.getters.Providers
                                                                ></v-combobox>
                                                            </v-col>
                                                            <v-col cols="4">
                                                                <v-text-field
                                                                    class="demofields"
                                                                    dense
                                                                    :label="(qaEnc && activeQaEnc.downcodes[dcind] ? 'Note: ' + activeQaEnc.downcodes[dcind].note + (activeQaEnc.downcodes[dcind].note == dc.note? ' - ✓' : ' - ✗' ) : 'Note')"
                                                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                    v-model="dc.note"
                                                                    outlined
                                                                ></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col style="padding:0" cols="1">
                                                        <v-row no-gutters style="margin-bottom:5px;margin-top:2px;">
                                                            <v-spacer></v-spacer>
                                                            <v-col style="padding:0" cols="9">
                                                                <v-btn
                                                                    depressed
                                                                    x-small
                                                                    color="error"
                                                                    :outlined="proMode"
                                                                    style="border-radius:0"
                                                                    block
                                                                    @click="deleteRow('dc',dcind,activeEnc.encid)"
                                                                    :disabled="readonly || activeEnc.downcodes.length==1"
                                                                >
                                                                    -
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters>
                                                            <v-spacer></v-spacer>
                                                            <v-col style="padding:0" cols="9">
                                                                <v-btn
                                                                    depressed
                                                                    x-small
                                                                    block
                                                                    color="success"
                                                                    :outlined="proMode"
                                                                    style="border-radius:0"
                                                                    @click="addRow('dc',dcind,activeEnc.encid)"
                                                                    :disabled="readonly"
                                                                >
                                                                    +
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </div>
                                        <v-row no-gutters v-if="$store.getters.facCodeTypes.indexOf('EM')!=-1">
                                            <v-col style="padding:0" cols="12">
                                                <v-row no-gutters style="height:40px;margin-top:5px;">
                                                    <v-col cols="1">
                                                        <v-text-field
                                                            class="demofields"
                                                            style="font-size:14px;font-weight:bold;"
                                                            dense
                                                            label="Type"
                                                            outlined
                                                            value="EM"
                                                            readonly
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="3">
                                                        <v-autocomplete
                                                            v-if="acepToolEnabled || $store.getters.facTools.indexOf('EM_TOOL_PRO_LT')!=-1"
                                                            class="demofields"
                                                            dense
                                                            outlined
                                                            :rules="fieldRule(activeEnc.codes.em[0].code,'EM_0_code')"
                                                            v-model="activeEnc.codes.em[0].code"
                                                            :items="$store.getters.emCodes"
                                                            :label="(qaEnc && activeQaEnc.codes.em[0] ? 'Code: ' + activeQaEnc.codes.em[0].code + (activeQaEnc.codes.em[0].code == activeEnc.codes.em[0].code ? ' - ✓' : ' - ✗' ) : 'Code')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        ></v-autocomplete>
                                                        <v-autocomplete
                                                            v-else
                                                            class="demofields"
                                                            dense
                                                            outlined
                                                            @input="checkCode(activeEnc.codes.em[0].code,false)"
                                                            @blur="checkCode(activeEnc.codes.em[0].code,false)"
                                                            :rules="fieldRule(activeEnc.codes.em[0].code,'EM_0_code')"
                                                            v-model="activeEnc.codes.em[0].code"
                                                            :items="$store.getters.emCodes"
                                                            :label="(qaEnc && activeQaEnc.codes.em[0] ? 'Code: ' + activeQaEnc.codes.em[0].code + (activeQaEnc.codes.em[0].code == activeEnc.codes.em[0].code ? ' - ✓' : ' - ✗' ) : 'Code')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        ></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="8">
                                                        <v-combobox
                                                            v-model="activeEnc.codes.em[0].mods"
                                                            @input="activeEnc.codes.em[0].mods = allCapArray(activeEnc.codes.em[0].mods)"
                                                            :items="$store.getters.emMods"
                                                            :label="(qaEnc && activeQaEnc.codes.em[0] ? 'Mods: ' + modStringer(activeQaEnc.codes.em[0].mods) + (activeQaEnc.codes.em[0].mods.toString() == activeEnc.codes.em[0].mods.toString() ? ' - ✓' : ' - ✗' ) : 'Modifiers')"
                                                            :rules="fieldRule(activeEnc.codes.em[0].mods,'EM_0_mods')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                            multiple
                                                            outlined
                                                            dense
                                                        >
                                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                                <v-chip
                                                                v-if="item === item"
                                                                v-bind="attrs"
                                                                :input-value="selected"
                                                                label
                                                                small
                                                                outlined
                                                                >
                                                                <span class="pr-2">
                                                                    {{ item }}
                                                                </span>
                                                                <v-icon
                                                                    x-small
                                                                    @click="parent.selectItem(item)"
                                                                >
                                                                    mdi-close
                                                                </v-icon>
                                                                </v-chip>
                                                            </template>
                                                        </v-combobox>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col style="padding:0" cols="12">
                                                <v-row no-gutters style="height:60px;margin-top:0px;">
                                                    <v-col cols="6">
                                                        <v-autocomplete
                                                        class="demofields"
                                                            dense
                                                            :label="(qaEnc && activeQaEnc.codes.em[0] ? 'BP: ' + getProviderDetail(activeQaEnc.codes.em[0].billing_provider) + (activeQaEnc.codes.em[0].billing_provider == activeEnc.codes.em[0].billing_provider ? ' - ✓' : ' - ✗' ) : 'Billing Provider')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                            :rules="fieldRuleDep(activeEnc.codes.em[0].billing_provider,'billing_provider',activeEnc.codes.em[0].code)"
                                                            v-model="activeEnc.codes.em[0].billing_provider"
                                                            outlined
                                                            item-text="displayName"
                                                            item-value="clientid"
                                                            :items=$store.getters.Providers
                                                        ></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <v-autocomplete
                                                        class="demofields"
                                                            dense
                                                            :label="(qaEnc && activeQaEnc.codes.em[0] ? 'SP: ' + getProviderDetail(activeQaEnc.codes.em[0].secondary_provider) + (activeQaEnc.codes.em[0].secondary_provider == activeEnc.codes.em[0].secondary_provider ? ' - ✓' : ' - ✗' ) : 'Secondary Provider')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                            :rules="fieldRuleDep(activeEnc.codes.em[0].secondary_provider,'secondary_provider',activeEnc.codes.em[0].code)"
                                                            v-model="activeEnc.codes.em[0].secondary_provider"
                                                            outlined
                                                            item-text="displayName"
                                                            item-value="clientid"
                                                            :items=$store.getters.Providers
                                                        ></v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="secondEM" no-gutters>
                                            <v-col style="padding:0" cols="12">
                                                <v-row no-gutters style="height:40px;margin-top:5px;">
                                                    <v-col cols="1">
                                                        <v-text-field
                                                            class="demofields"
                                                            style="font-size:14px;font-weight:bold;"
                                                            dense
                                                            label="Type"
                                                            outlined
                                                            value="EM"
                                                            readonly
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="3">
                                                        <v-autocomplete
                                                            class="demofields"
                                                            dense
                                                            outlined
                                                            v-model="activeEnc.codes.em[1].code"
                                                            :rules="fieldRule(activeEnc.codes.em[1].code,'EM_1_code')"
                                                            :items="$store.getters.emCodes"
                                                            :label="(qaEnc && activeQaEnc.codes.em[1] ? 'Code: ' + activeQaEnc.codes.em[1].code + (activeQaEnc.codes.em[1].code == activeEnc.codes.em[1].code ? ' - ✓' : ' - ✗' ) : 'Code')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        ></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="7">
                                                        <v-combobox
                                                            v-model="activeEnc.codes.em[1].mods"
                                                            :rules="fieldRule(activeEnc.codes.em[1].mods,'EM_1_mods')"
                                                            @input="activeEnc.codes.em[1].mods = allCapArray(activeEnc.codes.em[1].mods)"
                                                            :items="$store.getters.emMods"
                                                            :label="(qaEnc && activeQaEnc.codes.em[1] ? 'Mods: ' + modStringer(activeQaEnc.codes.em[1].mods) + (activeQaEnc.codes.em[1].mods.toString() == activeEnc.codes.em[1].mods.toString() ? ' - ✓' : ' - ✗' ) : 'Modifiers')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                            multiple
                                                            outlined
                                                            dense
                                                        >
                                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                                <v-chip
                                                                v-if="item === item"
                                                                v-bind="attrs"
                                                                :input-value="selected"
                                                                label
                                                                small
                                                                outlined
                                                                >
                                                                <span class="pr-2">
                                                                    {{ item }}
                                                                </span>
                                                                <v-icon
                                                                    x-small
                                                                    @click="parent.selectItem(item)"
                                                                >
                                                                    mdi-close
                                                                </v-icon>
                                                                </v-chip>
                                                            </template>
                                                        </v-combobox>
                                                    </v-col>
                                                    <v-col cols="1">
                                                        <v-text-field
                                                            class="demofields"
                                                            dense
                                                            :label="(qaEnc && activeQaEnc.codes.em[1] ? 'Q: ' + activeQaEnc.codes.em[1].qty + (activeQaEnc.codes.em[1].qty == activeEnc.codes.em[1].qty ? ' - ✓' : ' - ✗' ) : 'Qty')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                            type="number"
                                                            min="1"
                                                            v-model="activeEnc.codes.em[1].qty"
                                                            :rules="fieldRule(activeEnc.codes.em[1].code,'EM_qty')"
                                                            outlined
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col style="padding:0" cols="12">
                                                <v-row no-gutters style="height:60px;margin-top:0px;">
                                                    <v-col cols="6">
                                                        <v-autocomplete
                                                        class="demofields"
                                                            dense
                                                            :label="(qaEnc && activeQaEnc.codes.em[1] ? 'BP: ' + getProviderDetail(activeQaEnc.codes.em[1].billing_provider) + (activeQaEnc.codes.em[1].billing_provider == activeEnc.codes.em[1].billing_provider ? ' - ✓' : ' - ✗' ) : 'Billing Provider')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                            v-model="activeEnc.codes.em[1].billing_provider"
                                                            :rules="fieldRuleDep(activeEnc.codes.em[1].billing_provider,'billing_provider',activeEnc.codes.em[1].code)"
                                                            outlined
                                                            item-text="displayName"
                                                            item-value="clientid"
                                                            :items=$store.getters.Providers
                                                        ></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <v-autocomplete
                                                        class="demofields"
                                                            dense
                                                            :label="(qaEnc && activeQaEnc.codes.em[1] ? 'SP: ' + getProviderDetail(activeQaEnc.codes.em[1].secondary_provider) + (activeQaEnc.codes.em[1].secondary_provider == activeEnc.codes.em[1].secondary_provider ? ' - ✓' : ' - ✗' ) : 'Secondary Provider')"
                                                            :class="(qaEnc ? 'activeLabelOver' : '')"
                                                            v-model="activeEnc.codes.em[1].secondary_provider"
                                                            :rules="fieldRuleDep(activeEnc.codes.em[1].secondary_provider,'secondary_provider',activeEnc.codes.em[1].code)"
                                                            outlined
                                                            item-text="displayName"
                                                            item-value="clientid"
                                                            :items=$store.getters.Providers
                                                        ></v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-divider  v-if="$store.getters.facCodeTypes.indexOf('EM')!=-1" style="margin-top:-10px;margin-bottom:10px;"></v-divider>
                                        <div v-if="$store.getters.facCodeTypes.indexOf('CPT')!=-1" v-for="(cpt, cptind) in activeEnc.codes.cpt" :key="activeEnc.encid + '_cpt_' + cptind">
                                            <v-row no-gutters :key="cptchange">
                                                <v-col style="padding:0" cols="11">
                                                    <v-row no-gutters style="height:40px;margin-top:5px;">
                                                        <v-col cols="1">
                                                            <v-text-field
                                                                class="demofields"
                                                                style="font-size:14px;font-weight:bold;"
                                                                dense
                                                                label="Type"
                                                                outlined
                                                                value="CPT"
                                                                readonly
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <v-autocomplete
                                                                class="demofields"
                                                                dense
                                                                outlined
                                                                v-model="cpt.code"
                                                                :rules="fieldRule(cpt.code,'CPT_code')"
                                                                :items="$store.getters.cptCodes"
                                                                :label="(qaEnc && activeQaEnc.codes.cpt[cptind] ? 'Code: ' + activeQaEnc.codes.cpt[cptind].code + (activeQaEnc.codes.cpt[cptind].code == cpt.code ? ' - ✓' : ' - ✗' ) : 'Code')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                            ></v-autocomplete>
                                                        </v-col>
                                                        <v-col cols="7">
                                                            <!-- <v-combobox
                                                                v-model="cpt.mods"
                                                                :items="$store.getters.cptMods"
                                                                label="Modifiers"
                                                                multiple
                                                                outlined
                                                                dense
                                                            ></v-combobox> -->
                                                            <v-combobox
                                                                v-model="cpt.mods"
                                                                @input="cpt.mods = allCapArray(cpt.mods)"
                                                                :rules="fieldRule(cpt.mods,'CPT_mods')"
                                                                :items="$store.getters.cptMods"
                                                                :label="(qaEnc && activeQaEnc.codes.cpt[cptind] ? 'Mods: ' + modStringer(activeQaEnc.codes.cpt[cptind].mods) + (activeQaEnc.codes.cpt[cptind].mods.toString() == cpt.mods.toString() ? ' - ✓' : ' - ✗' ) : 'Modifiers')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                multiple
                                                                outlined
                                                                dense
                                                            >
                                                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                                                    <v-chip
                                                                    v-if="item === item"
                                                                    v-bind="attrs"
                                                                    :input-value="selected"
                                                                    label
                                                                    small
                                                                    outlined
                                                                    >
                                                                    <span class="pr-2">
                                                                        {{ item }}
                                                                    </span>
                                                                    <v-icon
                                                                        x-small
                                                                        @click="parent.selectItem(item)"
                                                                    >
                                                                        mdi-close

                                                                    </v-icon>
                                                                    </v-chip>
                                                                </template>
                                                            </v-combobox>
                                                        </v-col>
                                                        <v-col cols="1">
                                                            <v-text-field
                                                                class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.codes.cpt[cptind] ? 'Q: ' + activeQaEnc.codes.cpt[cptind].qty + (activeQaEnc.codes.cpt[cptind].qty == cpt.qty ? ' - ✓' : ' - ✗' ) : 'Qty')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                type="number"
                                                                min="1"
                                                                v-model="cpt.qty"
                                                                :rules="fieldRule(cpt.code,'CPT_qty')"
                                                                outlined
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row no-gutters style="height:60px;margin-top:0px;">
                                                        <v-col cols="3">
                                                            <v-menu
                                                                v-model="menu2[cptind]"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="290px"
                                                                :disabled="readonly"
                                                            >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field
                                                                    class="demofields"
                                                                    v-model="cpt.date_performed"
                                                                    :rules="fieldRuleDep(cpt.date_performed,'CPT_date_performed',cpt.code)"
                                                                    :label="(qaEnc && activeQaEnc.codes.cpt[cptind] ? 'Date: ' + activeQaEnc.codes.cpt[cptind].date_performed + (activeQaEnc.codes.cpt[cptind].date_performed == cpt.date_performed ? ' - ✓' : ' - ✗' ) : 'Date Performed')"
                                                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                    dense
                                                                    outlined
                                                                    readonly
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="cpt.date_performed"
                                                                    @input="menu2[cptind] = false"
                                                                ></v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col cols="5">
                                                            <v-autocomplete
                                                            class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.codes.cpt[cptind] ? 'BP: ' + getProviderDetail(activeQaEnc.codes.cpt[cptind].billing_provider) + (activeQaEnc.codes.cpt[cptind].billing_provider == cpt.billing_provider ? ' - ✓' : ' - ✗' ) : 'Billing Provider')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                v-model="cpt.billing_provider"
                                                                :rules="fieldRuleDep(cpt.billing_provider,'billing_provider',cpt.code)"
                                                                outlined
                                                                item-text="displayName"
                                                                item-value="clientid"
                                                                :items=$store.getters.Providers
                                                            ></v-autocomplete>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-autocomplete
                                                            class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.codes.cpt[cptind] ? 'SP: ' + getProviderDetail(activeQaEnc.codes.cpt[cptind].secondary_provider) + (activeQaEnc.codes.cpt[cptind].secondary_provider == cpt.secondary_provider ? ' - ✓' : ' - ✗' ) : 'Secondary Provider')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                v-model="cpt.secondary_provider"
                                                                :rules="fieldRuleDep(cpt.secondary_provider,'secondary_provider',cpt.code)"
                                                                outlined
                                                                item-text="displayName"
                                                                item-value="clientid"
                                                                :items=$store.getters.Providers
                                                            ></v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col style="padding:0" cols="1">
                                                    <v-row no-gutters style="margin-bottom:5px;margin-top:23px;">
                                                        <v-spacer></v-spacer>
                                                        <v-col style="padding:0" cols="9">
                                                            <v-btn
                                                                depressed
                                                                x-small
                                                                color="error"
                                                                :outlined="proMode"
                                                                style="border-radius:0"
                                                                block
                                                                :disabled="readonly"
                                                                @click="deleteRow('cpt',cptind,activeEnc.encid)"
                                                            >
                                                                -
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row no-gutters>
                                                        <v-spacer></v-spacer>
                                                        <v-col style="padding:0" cols="9">
                                                            <v-btn
                                                                depressed
                                                                x-small
                                                                block
                                                                color="success"
                                                                :outlined="proMode"
                                                                style="border-radius:0"
                                                                :disabled="readonly"
                                                                @click="addRow('cpt',cptind,activeEnc.encid)"
                                                            >
                                                                +
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider v-if="$store.getters.facCodeTypes.indexOf('CPT')!=-1" style="margin-top:-10px;margin-bottom:10px;"></v-divider>

                                        <div v-if="$store.getters.facCodeTypes.indexOf('HCPCS')!=-1" v-for="(hcpcs, hcpcsind) in activeEnc.codes.hcpcs" :key="activeEnc.encid + '_hcpcs_' + hcpcsind">
                                            <v-row no-gutters>
                                                <v-col style="padding:0" cols="11">
                                                    <v-row no-gutters style="height:40px;margin-top:5px;">
                                                        <v-col cols="1">
                                                            <v-text-field
                                                                class="demofields"
                                                                style="font-size:14px;font-weight:bold;"
                                                                dense
                                                                label="Type"
                                                                outlined
                                                                value="HCPCS"
                                                                readonly
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <HCPCSAPI
                                                                v-model="hcpcs.code"
                                                                :key="hcpcschange"
                                                                :ro="readonly"
                                                                :qaVal="(qaEnc && activeQaEnc.codes.hcpcs[hcpcsind] ? activeQaEnc.codes.hcpcs[hcpcsind].code : null)"
                                                            />
                                                        </v-col>
                                                        <v-col cols="7">
                                                            <!-- <v-combobox
                                                                v-model="cpt.mods"
                                                                :items="$store.getters.cptMods"
                                                                label="Modifiers"
                                                                multiple
                                                                outlined
                                                                dense
                                                            ></v-combobox> -->
                                                            <v-combobox
                                                                v-model="hcpcs.mods"
                                                                @input="hcpcs.mods = allCapArray(hcpcs.mods)"
                                                                :rules="fieldRule(hcpcs.mods,'HCPCS_mods')"
                                                                :items="$store.getters.cptMods"
                                                                :label="(qaEnc && activeQaEnc.codes.hcpcs[hcpcsind] ? 'Mods: ' + modStringer(activeQaEnc.codes.hcpcs[hcpcsind].mods) + (activeQaEnc.codes.hcpcs[hcpcsind].mods.toString() == hcpcs.mods.toString() ? ' - ✓' : ' - ✗' ) : 'Modifiers')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                multiple
                                                                outlined
                                                                dense
                                                            >
                                                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                                                    <v-chip
                                                                    v-if="item === item"
                                                                    v-bind="attrs"
                                                                    :input-value="selected"
                                                                    label
                                                                    small
                                                                    outlined
                                                                    >
                                                                    <span class="pr-2">
                                                                        {{ item }}
                                                                    </span>
                                                                    <v-icon
                                                                        x-small
                                                                        @click="parent.selectItem(item)"
                                                                    >
                                                                        mdi-close

                                                                    </v-icon>
                                                                    </v-chip>
                                                                </template>
                                                            </v-combobox>
                                                        </v-col>
                                                        <v-col cols="1">
                                                            <v-text-field
                                                                class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.codes.hcpcs[hcpcsind] ? 'Q: ' + activeQaEnc.codes.hcpcs[hcpcsind].qty + (activeQaEnc.codes.hcpcs[hcpcsind].qty == hcpcs.qty ? ' - ✓' : ' - ✗' ) : 'Qty')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                type="number"
                                                                min="1"
                                                                v-model="hcpcs.qty"
                                                                :rules="fieldRule(hcpcs.code,'HCPCS_qty')"
                                                                outlined
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row no-gutters style="height:60px;margin-top:0px;">
                                                        <v-col cols="6">
                                                            <v-autocomplete
                                                            class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.codes.hcpcs[hcpcsind] ? 'BP: ' + getProviderDetail(activeQaEnc.codes.hcpcs[hcpcsind].billing_provider) + (activeQaEnc.codes.hcpcs[hcpcsind].billing_provider == hcpcs.billing_provider ? ' - ✓' : ' - ✗' ) : 'Billing Provider')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                v-model="hcpcs.billing_provider"
                                                                :rules="fieldRuleDep(hcpcs.billing_provider,'billing_provider',hcpcs.code)"
                                                                outlined
                                                                item-text="displayName"
                                                                item-value="clientid"
                                                                :items=$store.getters.Providers
                                                            ></v-autocomplete>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-autocomplete
                                                            class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.codes.hcpcs[hcpcsind] ? 'SP: ' + getProviderDetail(activeQaEnc.codes.hcpcs[hcpcsind].secondary_provider) + (activeQaEnc.codes.hcpcs[hcpcsind].secondary_provider == hcpcs.secondary_provider ? ' - ✓' : ' - ✗' ) : 'Secondary Provider')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                v-model="hcpcs.secondary_provider"
                                                                :rules="fieldRuleDep(hcpcs.secondary_provider,'secondary_provider',hcpcs.code)"
                                                                outlined
                                                                item-text="displayName"
                                                                item-value="clientid"
                                                                :items=$store.getters.Providers
                                                            ></v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col style="padding:0" cols="1">
                                                    <v-row no-gutters style="margin-bottom:5px;margin-top:23px;">
                                                        <v-spacer></v-spacer>
                                                        <v-col style="padding:0" cols="9">
                                                            <v-btn
                                                                depressed
                                                                x-small
                                                                color="error"
                                                                :outlined="proMode"
                                                                style="border-radius:0"
                                                                block
                                                                :disabled="readonly"
                                                                @click="deleteRow('hcpcs',hcpcsind,activeEnc.encid)"
                                                            >
                                                                -
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row no-gutters>
                                                        <v-spacer></v-spacer>
                                                        <v-col style="padding:0" cols="9">
                                                            <v-btn
                                                                depressed
                                                                x-small
                                                                block
                                                                color="success"
                                                                :outlined="proMode"
                                                                style="border-radius:0"
                                                                :disabled="readonly"
                                                                @click="addRow('hcpcs',hcpcsind,activeEnc.encid)"
                                                            >
                                                                +
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider v-if="$store.getters.facCodeTypes.indexOf('HCPCS')!=-1" style="margin-top:-10px;margin-bottom:10px;"></v-divider>

                                        <v-row v-if="$store.getters.facCodeTypes.indexOf('DX')!=-1 && !dxValid(0)" no-gutters>
                                            <v-col cols="12">
                                                <div :class="'v-messages theme--dark ' + ( readonly ? '' : 'error--text')" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message">*Primary DX Required to QA/Complete</div></div></div>
                                                <!-- <span >Primary DX Required to QA/Complete</span> -->
                                            </v-col>
                                        </v-row>
                                        <div v-if="$store.getters.facCodeTypes.indexOf('DX')!=-1" v-for="(dx, dxind) in activeEnc.codes.dx" :key="activeEnc.encid + '_dx_' + dxind">
                                            <v-row no-gutters>
                                                <v-col style="padding:0" cols="1">
                                                    <v-row no-gutters style="margin-bottom:5px;margin-top:2px;">
                                                        <v-col style="padding:0" cols="9">
                                                            <v-btn
                                                                depressed
                                                                :disabled="dxind==0 || readonly"
                                                                x-small
                                                                :outlined="proMode"
                                                                style="border-radius:0"
                                                                block
                                                                @click="moveRow('dx',dxind,'up')"
                                                            >
                                                                <v-icon small>mdi-chevron-up</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                        <v-spacer></v-spacer>
                                                    </v-row>
                                                    <v-row no-gutters>
                                                        <v-col style="padding:0" cols="9">
                                                            <v-btn
                                                                depressed
                                                                x-small
                                                                :disabled="dxind==activeEnc.codes.dx.length-1 || readonly"
                                                                block
                                                                :outlined="proMode"
                                                                style="border-radius:0"
                                                                @click="moveRow('dx',dxind,'down')"
                                                            >
                                                                <v-icon small>mdi-chevron-down</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                        <v-spacer></v-spacer>
                                                    </v-row>
                                                </v-col>
                                                <v-col style="padding:0" cols="10">
                                                    <v-row no-gutters style="height:60px;margin-top:5px;">
                                                        <v-col cols="1">
                                                            <v-text-field
                                                                class="demofields"
                                                                style="font-size:14px;font-weight:bold;"
                                                                dense
                                                                label="Type"
                                                                outlined
                                                                value="DX"
                                                                readonly
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-text-field
                                                                v-show="false"
                                                                dense
                                                                outlined
                                                                :rules="fieldRuleInd(dx.code,'DX_code',dxind)"
                                                                v-model="dx.code"
                                                            ></v-text-field>
                                                            <DXAPI
                                                                v-model="dx.code"
                                                                :key="dxchange"
                                                                :ro="readonly"
                                                                :qaVal="(qaEnc && activeQaEnc.codes.dx[dxind] ? activeQaEnc.codes.dx[dxind].code : null)"
                                                            />
                                                        </v-col>
                                                        <!-- <v-col cols="3">
                                                            <v-checkbox
                                                                style="margin:2px 10px;"
                                                                v-model="dx.unspecified"
                                                                :rules="fieldRule(dx.unspecified,'DX_unspecified')"
                                                                :label="(qaEnc && activeQaEnc.codes.dx[dxind] ? 'Unsp: ' + activeQaEnc.codes.dx[dxind].unspecified + (activeQaEnc.codes.dx[dxind].unspecified == dx.unspecified ? ' - ✓' : ' - ✗' ) : 'Unspecified')"
                                                            ></v-checkbox>
                                                        </v-col> -->
                                                        <v-col cols="5">
                                                            <v-select
                                                                class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.codes.dx[dxind] ? 'ReCPT: ' + (typeof activeQaEnc.codes.dx[dxind].related_cpt === 'object' && activeQaEnc.codes.dx[dxind].related_cpt !== null ? '' : activeQaEnc.codes.dx[dxind].related_cpt + (activeQaEnc.codes.dx[dxind].related_cpt == dx.related_cpt ? ' - ✓' : ' - ✗' )) : 'Related CPT')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                v-model="dx.related_cpt"
                                                                :rules="fieldRule(dx.related_cpt,'related_cpt')"
                                                                outlined
                                                                :items=relCPT
                                                            ></v-select>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col style="padding:0" cols="1">
                                                    <v-row no-gutters style="margin-bottom:5px;margin-top:2px;">
                                                        <v-spacer></v-spacer>
                                                        <v-col style="padding:0" cols="9">
                                                            <v-btn
                                                                depressed
                                                                x-small
                                                                color="error"
                                                                :outlined="proMode"
                                                                style="border-radius:0"
                                                                block
                                                                @click="deleteRow('dx',dxind,activeEnc.encid)"
                                                                :disabled="readonly"
                                                            >
                                                                -
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row no-gutters>
                                                        <v-spacer></v-spacer>
                                                        <v-col style="padding:0" cols="9">
                                                            <v-btn
                                                                depressed
                                                                x-small
                                                                block
                                                                color="success"
                                                                :outlined="proMode"
                                                                style="border-radius:0"
                                                                @click="addRow('dx',dxind,activeEnc.encid)"
                                                                :disabled="readonly"
                                                            >
                                                                +
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider style="margin-top:-10px;margin-bottom:10px;"></v-divider>
                                        <div v-for="(cdi,cdiind) in activeEnc.cdis" :key="activeEnc.encid + '_cdi_' + cdiind">
                                            <v-row no-gutters :key="cdichange">
                                                <v-col style="padding:0" cols="11">
                                                    <v-row no-gutters style="height:60px;margin-top:5px;">
                                                        <v-col cols="1">
                                                            <v-text-field
                                                                class="demofields"
                                                                style="font-size:14px;font-weight:bold;"
                                                                dense
                                                                label="Type"
                                                                outlined
                                                                value="CDI"
                                                                readonly
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <v-select
                                                            class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.cdis[cdiind] ? 'Area: ' + activeQaEnc.cdis[cdiind].area + (activeQaEnc.cdis[cdiind].area == cdi.area? ' - ✓' : ' - ✗' ) : 'Area')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                v-model="cdi.area"
                                                                outlined
                                                                :items=$store.getters.cdiReasons
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="1">
                                                            <v-text-field
                                                                class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.cdis[cdiind] ? 'Q: ' + activeQaEnc.cdis[cdiind].qty + (activeQaEnc.cdis[cdiind].qty == cdi.qty? ' - ✓' : ' - ✗' ) : 'Qty')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                type="number"
                                                                min="1"
                                                                v-model="cdi.qty"
                                                                outlined
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <v-combobox
                                                                class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.cdis[cdiind] ? 'Nurse: ' + activeQaEnc.cdis[cdiind].nurse + (activeQaEnc.cdis[cdiind].nurse == cdi.nurse? ' - ✓' : ' - ✗' ) : 'Nurse')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                v-model="cdi.nurse"
                                                                @input="cdi.nurse = objToValue(cdi.nurse,'displayName')"
                                                                outlined
                                                                item-text="displayName"
                                                                item-value="displayName"
                                                                :items=$store.getters.Providers
                                                            ></v-combobox>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-text-field
                                                                class="demofields"
                                                                dense
                                                                :label="(qaEnc && activeQaEnc.cdis[cdiind] ? 'Note: ' + activeQaEnc.cdis[cdiind].note + (activeQaEnc.cdis[cdiind].note == cdi.note? ' - ✓' : ' - ✗' ) : 'Note')"
                                                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                                                v-model="cdi.note"
                                                                outlined
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col style="padding:0" cols="1">
                                                    <v-row no-gutters style="margin-bottom:5px;margin-top:2px;">
                                                        <v-spacer></v-spacer>
                                                        <v-col style="padding:0" cols="9">
                                                            <v-btn
                                                                depressed
                                                                x-small
                                                                color="error"
                                                                :outlined="proMode"
                                                                style="border-radius:0"
                                                                block
                                                                @click="deleteRow('cdi',cdiind,activeEnc.encid)"
                                                                :disabled="readonly"
                                                            >
                                                                -
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row no-gutters>
                                                        <v-spacer></v-spacer>
                                                        <v-col style="padding:0" cols="9">
                                                            <v-btn
                                                                depressed
                                                                x-small
                                                                block
                                                                color="success"
                                                                :outlined="proMode"
                                                                style="border-radius:0"
                                                                @click="addRow('cdi',cdiind,activeEnc.encid)"
                                                                :disabled="readonly"
                                                            >
                                                                +
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider v-if="qaEnc" style="margin-top:-10px;margin-bottom:10px;"></v-divider>
                                        <v-row v-if="qaEnc">
                                            <v-col cols="12" style="text-align:center;">
                                                <v-textarea
                                                    class="textareafix4"
                                                    dense
                                                    :label="(activeEnc.qa_notes[0].note.length > 0 ? 'QA Note - ' + activeEnc.qa_notes[0].user + ' - ' + new Date(activeEnc.qa_notes[0].time).toLocaleString() : 'QA Note')"
                                                    v-model="activeEnc.qa_notes[0].note"
                                                    outlined
                                                    :readonly="readonly"
                                                    rows="4"
                                                ></v-textarea>
                                            </v-col>
                                        </v-row>
                                        <v-divider style="margin-top:10px;margin-bottom:0;"></v-divider>
                                        <v-row v-if="encLogs.length>0">
                                            <v-col cols="12">
                                                <v-card>
                                                    <v-card-title>
                                                    History Logs
                                                    <v-spacer></v-spacer>
                                                    <!-- <v-text-field
                                                        v-model="encLogSearch"
                                                        append-icon="mdi-magnify"
                                                        disabled="false"
                                                        label="Search"
                                                        single-line
                                                        dense
                                                        hide-details
                                                    ></v-text-field> -->
                                                    </v-card-title>
                                                    <v-data-table
                                                        :headers="logHeaders"
                                                        :search="encLogSearch"
                                                        :items="encLogs"
                                                        sort-by="change_time"
                                                        sort-desc
                                                        :items-per-page="5"
                                                        :class="proMode ? 'encLogTable' : 'encLogTableLt'"
                                                        :footer-props="{
                                                            showFirstLastPage:true
                                                        }"
                                                        dense
                                                    >
                                                        <template v-slot:item.change_time="{ item }">
                                                            {{new Date(item.change_time).toLocaleString()}}
                                                        </template>
                                                        <template v-slot:item.view="{ item }">
                                                            <v-btn
                                                                :color="proMode ? 'white' : 'black'"
                                                                small
                                                                text
                                                                class="px-0"
                                                                :disabled="item.status=='IN PROGRESS'"
                                                                @click="openLog(item)"
                                                            >
                                                                <v-icon small>mdi-book-open-outline</v-icon>
                                                            </v-btn>
                                                        </template>
                                                    </v-data-table>
                                                </v-card>
                                                
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions style="border-top:1px solid darkslategrey;padding-top:5px;">
                                    <v-row v-if="readonly">
                                        <v-col cols="3">
                                            <v-btn
                                                color="error"
                                                :outlined="proMode"
                                                block
                                                small
                                                :text="proMode"
                                                @click="deficientdialog=true"
                                            >
                                                DEFICIENTS ({{(activeEnc.deficients ? activeEnc.deficients.length : 0)}})
                                            </v-btn>
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-col :cols="(activeEnc.status == 'QA' ? 4 : 8)">
                                            <v-btn
                                                :outlined="proMode"
                                                block
                                                small
                                                :text="proMode"
                                                style="border-radius:0"
                                                :color="(activeEnc.status == 'QA' ? 'warning' : 'success')"
                                                @click="editOpen"
                                                :disabled="activeEnc.status == 'EXPORT'"
                                            >
                                                {{activeEnc.status == 'QA' ? "QA " : "EDIT "}} ENCOUNTER
                                            </v-btn>
                                        </v-col>
                                        <v-col v-if="activeEnc.status == 'QA'" cols="4">
                                            <v-btn
                                                :outlined="proMode"
                                                block
                                                :text="proMode"
                                                small
                                                style="border-radius:0"
                                                color="success"
                                                @click="save('COMPLETE')"
                                                :disabled="!activeEnc.encid || !encValid"
                                            >
                                                COMPLETE
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row v-else>
                                        <v-col cols="3">
                                            <v-btn
                                                color="error"
                                                :outlined="proMode"
                                                block
                                                small
                                                :text="proMode"
                                                @click="deficientdialog=true"
                                                :disabled="!activeEnc.encid"
                                            >
                                                DEFICIENTS ({{(activeEnc.deficients ? activeEnc.deficients.length : 0)}})
                                            </v-btn>
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-col cols="3">
                                            <v-btn
                                                :outlined="proMode"
                                                block
                                                small
                                                :text="proMode"
                                                style="border-radius:0"
                                                color="primary"
                                                @click="save('INCOMPLETE')"
                                                :disabled="!activeEnc.encid"
                                            >
                                                SAVE INCOMPLETE
                                            </v-btn>
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-col cols="3">
                                            <v-btn
                                                :outlined="proMode"
                                                block
                                                small
                                                :text="proMode"
                                                :style="'border-radius:0;color:'+(proMode ? '' : 'white')"
                                                color="orange darken-3"
                                                @click="save('QA')"
                                                :disabled="!activeEnc.encid || !encValid"
                                            >
                                                SAVE QA
                                            </v-btn>
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-col cols="3">
                                            <v-btn
                                                :outlined="proMode"
                                                block
                                                :text="proMode"
                                                small
                                                style="border-radius:0"
                                                color="success"
                                                @click="save('COMPLETE')"
                                                :disabled="!activeEnc.encid || !encValid"
                                            >
                                                COMPLETE
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-dialog
            v-if="notesdialog"
            v-model="notesdialog"
            scrollable
            max-width="800px"
            @click:outside="closeNotes"
        >
            <!-- <template v-slot:activator="{ on, attrs }">
                <v-btn
                :color="proMode ? 'white' : 'black'"
                small
                text
                v-bind="attrs"
                v-on="on"
                :disabled="!activeEnc.encid"
                class="px-0"
                >
                    <v-icon>mdi-note-text</v-icon> {{(activeEnc.notes.length > 0 ? "(" + activeEnc.notes.length + ")" : "")}}
                </v-btn>
            </template> -->
            <v-card  :dark="proMode">
                <v-card-title>
                    Notes for 
                    {{
                        activeEnc.ext_id + " | " + 
                        activeEnc.demographics.lastName + ", " + activeEnc.demographics.firstName + " - " +
                        activeEnc.dos
                    }}
                    <v-spacer></v-spacer>
                    <v-icon >mdi-note-text</v-icon> ({{(activeEnc.notes ? activeEnc.notes.length : 0)}})
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 400px; padding-top:10px;">
                    <v-row style="height:90px;margin-top:10px;" v-for="(note,noteind) in activeEnc.notes" :key="activeEnc.encid + '_note_' + noteind + '_' + wsUps">
                        <v-col class="pa-0" cols="12">
                            <v-textarea
                                class="demofields textareafix"
                                dense
                                :label="note.note_type + ': ' + note.user + ' - ' + new Date(note.time).toLocaleString()"
                                v-model="note.note"
                                outlined
                                readonly
                                rows="4"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row class="mt-1 mb-2">
                        <v-divider></v-divider>
                    </v-row>
                    <v-row class="">
                        <v-col style="padding:0" cols="12">
                            <v-row no-gutters style="height:40px;margin-top:5px;">
                                <v-col cols="12">
                                    <v-select
                                        class="demofields"
                                        dense
                                        label="Note Type"
                                        v-model="newnote.note_type"
                                        outlined
                                        :items=$store.getters.noteTypes
                                    ></v-select>
                                </v-col>
                                <!-- <v-col cols="6">
                                    <v-autocomplete
                                        class="demofields"
                                        dense
                                        label="Notify User"
                                        v-model="newnote.user"
                                        outlined
                                        item-text="user_name"
                                        item-value="userid"
                                        :items=$store.getters.Users
                                    ></v-autocomplete>
                                </v-col> -->
                            </v-row>
                            <v-row no-gutters style="height:60px;margin-top:5px;">
                                <v-col cols="12">
                                    <v-textarea
                                        class="demofields textareafix"
                                        dense
                                        label="Note"
                                        v-model="newnote.note"
                                        rows="4"
                                        outlined
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mt-9">
                                <v-col cols="12">
                                    <v-btn
                                        color="success"
                                        :text="proMode"
                                        :outlined="proMode"
                                        block
                                        style="border-radius:0"
                                        @click="saveNote"
                                        :disabled="activeEnc.status != 'EXPORT' && newnote.note.length < 1"
                                    >
                                        ADD NOTE +
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <!-- <v-spacer></v-spacer>
                    <v-col cols="4">
                        <v-btn
                            color="primary"
                            text
                            outlined
                            :disabled="activeEnc.deficients && activeEnc.deficients.length==0"
                            block
                            style="border-radius:0"
                            @click="save('WAITING')"
                        >
                            UPDATE WAITING
                        </v-btn>
                    </v-col> 
                    <v-spacer></v-spacer> -->
                    <v-col cols="12">
                        <v-btn
                            color="primary"
                            :text="proMode"
                            :outlined="proMode"
                            block
                            style="border-radius:0"
                            @click="closeNotes"
                        >
                            CLOSE NOTES
                        </v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="deficientdialog"
            v-model="deficientdialog"
            scrollable
            max-width="800px"
            @click:outside="closeDefs"
        >
            <v-card  :dark="proMode">
                <v-card-title>
                    Deficients for 
                    {{
                        activeEnc.ext_id + " | " + 
                        activeEnc.demographics.lastName + ", " + activeEnc.demographics.firstName + " - " +
                        activeEnc.dos
                    }}
                    <v-spacer></v-spacer>
                    <v-icon >mdi-alert-octagon-outline</v-icon> ({{(activeEnc.deficients ? activeEnc.deficients.length : 0)}})
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 400px; padding-top:10px;">
                    <v-row v-for="(deficient,defind) in activeEnc.deficients" :key="activeEnc.encid + '_sus_' + defind">
                        <v-col cols="12" class="pa-0">
                            <v-row no-gutters>
                                <v-col class="pa-0 text-subtitle-1" style="color:white" cols="12">
                                    {{deficient.user + ' - ' + new Date(deficient.time).toLocaleString()}}
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col class="pa-0" cols="6">
                                    <v-text-field
                                        class="demofields"
                                        dense
                                        label="Reason"
                                        v-model="deficient.deficient_reason"
                                        outlined
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pa-0" cols="6">
                                    <v-text-field
                                        class="demofields"
                                        dense
                                        label="Provider"
                                        v-model="deficient.provider"
                                        outlined
                                        readonly
                                        type="text"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters style="margin-top:-10px">
                                <v-col class="pa-0" cols="12">
                                    <v-textarea
                                        class="demofields textareafix textareafix2"
                                        dense
                                        label="Note"
                                        v-model="deficient.note"
                                        outlined
                                        readonly
                                        rows="2"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2 mb-2" v-if="activeEnc.status != 'EXPORT' && defAdded">
                        <v-divider></v-divider>
                    </v-row>
                    <v-row no-gutters class="mt-0" v-if="activeEnc.status != 'EXPORT' && defAdded">
                        <v-col class="text-center text-subtitle-1 red--text font-italic" cols="12">
                            NOTE: You must still "Mark Deficient" to change status to Deficient.
                        </v-col>
                    </v-row>
                    <v-row class="mt-2 mb-2" v-if="activeEnc.status != 'EXPORT'">
                        <v-divider></v-divider>
                    </v-row>
                    <v-row class="" v-if="activeEnc.status != 'EXPORT'">
                        <v-col style="padding:0" cols="12">
                            <v-row no-gutters style="height:40px;margin-top:5px;">
                                <v-col cols="6">
                                    <v-select
                                        class="demofields"
                                        dense
                                        label="Deficient Reason"
                                        v-model="newDef.deficient_reason"
                                        outlined
                                        :items=$store.getters.deficientReasons
                                    ></v-select>
                                </v-col>
                                <v-col cols="6">
                                    <v-autocomplete
                                        class="demofields"
                                        dense
                                        label="Provider"
                                        v-model="newDef.provider"
                                        outlined
                                        item-text="displayName"
                                        item-value="clientid"
                                        :items=$store.getters.Providers
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row no-gutters style="height:40px;margin-top:5px;">
                                <v-col cols="12">
                                    <v-textarea
                                        class="demofields"
                                        dense
                                        label="Note"
                                        v-model="newDef.note"
                                        outlined
                                        rows="2"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mt-9">
                                <v-col cols="12">
                                    <v-btn
                                        color="success"
                                        :text="proMode"
                                        :outlined="proMode"
                                        block
                                        style="border-radius:0"
                                        @click="addDef"
                                        :disabled="!newDef.deficient_reason && activeEnc.status != 'EXPORT'"
                                    >
                                        ADD DEFICIENT REASON +
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-col cols="4">
                        <v-btn
                            color="warning"
                            :text="proMode"
                            :outlined="proMode"
                            block
                            style="border-radius:0"
                            @click="closeDefs"
                        >
                            CANCEL
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <!-- <v-col cols="4">
                        <v-btn
                            color="primary"
                            :text="proMode"
                            :outlined="proMode"
                            :disabled="activeEnc.deficients && activeEnc.deficients.length==0"
                            block
                            style="border-radius:0"
                            @click="save('WAITING')"
                        >
                            UPDATE WAITING
                        </v-btn>
                    </v-col> -->
                    <v-spacer></v-spacer>
                    <v-col cols="4">
                        <v-btn
                            color="error"
                            :text="proMode"
                            :outlined="proMode"
                            block
                            style="border-radius:0"
                            @click="save('DEFICIENT')"
                            :disabled="activeEnc.status == 'EXPORT' || activeEnc.deficients.length==0"
                        >
                            MARK DEFICIENT
                        </v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="logdetaildialog"
            scrollable
            max-width="800px"
            @click:outside="closeLogDetail"
        >
            <v-card  :dark="proMode">
                <v-card-title>
                    Details for 
                    {{
                        selectedLog.ext_id + " | " + 
                        selectedLog.status + " | " + new Date(selectedLog.change_time).toLocaleString()
                        + " - " + selectedLog.user
                    }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="encLogDetail.demographics" style="height: 400px; padding-top:10px;">
                    <!-- {{JSON.stringify(encLogDetail,null,2)}} -->
                    <v-row no-gutters class="mb-2">
                        <v-col cols="12">
                            <v-simple-table style="border-radius:0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="7">
                                            Demographic Data
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-left">
                                            MRN
                                        </th>
                                        <th class="text-left">
                                            Name
                                        </th>
                                        <th class="text-left">
                                            Sex
                                        </th>
                                        <th class="text-left">
                                            DOB
                                        </th>
                                        <th class="text-left">
                                            Payer
                                        </th>
                                        <th class="text-left">
                                            Disch
                                        </th>
                                        <th class="text-left">
                                            Acc Date
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ encLogDetail.demographics.mrn }}</td>
                                        <td>{{ encLogDetail.demographics.lastName }}, {{ encLogDetail.demographics.firstName }}</td>
                                        <td>{{ encLogDetail.demographics.gender }}</td>
                                        <td>{{ encLogDetail.demographics.dob }}</td>
                                        <td>{{ encLogDetail.demographics.payer }}</td>
                                        <td>{{ (encLogDetail.discharge_disposition ? encLogDetail.discharge_disposition : "" ) }}</td>
                                        <td>{{ (encLogDetail.accident_date ? encLogDetail.accident_date : "") }}</td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-2">
                        <v-col cols="12">
                            <v-tabs
                                :dark="proMode"
                                show-arrows
                                v-model="logdetaildostab"
                                grow
                                :style="'border-radius: 0;border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                            >
                                <v-tabs-slider :color="proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'"></v-tabs-slider>
                                <v-tab :style="'border:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')">
                                    DOS: {{encLogDetail.dos}}
                                </v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="logdetaildostab">
                                <v-tab-item>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                            EM(s)
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left">
                                                            Code
                                                        </th>
                                                        <th class="text-left">
                                                            Mod(s)
                                                        </th>
                                                        <th class="text-left">
                                                            Billing Prov
                                                        </th>
                                                        <th class="text-left">
                                                            Secondary Prov
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="em in encLogDetail.codes.em">
                                                        <tr :key="(em.id ? em.id : em.code)">
                                                            <td>{{ (em.code ? em.code : "" ) }}</td>
                                                            <td>
                                                                <span v-if="em.mod"><span v-for="(mod,i) in em.mods" :key="mod">{{ mod }}{{(em.mods.length != i+1 ? ", " : "")}}</span></span>
                                                            </td>
                                                            <td>{{ (em.billing_provider ? getProviderDetail(em.billing_provider) : "") }}</td>
                                                            <td>{{ (em.secondary_provider ? getProviderDetail(em.secondary_provider) : "") }}</td>
                                                        </tr>
                                                        <tr v-if="em.tool && em.tool.selected && em.tool.selected[0] && em.tool.selected[0].description"  :key="(em.id ? em.id : em.code)">
                                                            <td colspan="4">
                                                                <span v-if="em.tool.selected[0]">
                                                                    Tool Desc: <span v-for="(res,i) in em.tool.selected" :key="res">{{ res.description }}{{(em.tool.selected.length != i+1 ? ", " : "")}}</span>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="em.tool && em.tool.note" :key="(em.id ? em.id : em.code)">
                                                            <td colspan="4">Tool Note: {{ (em.tool.note ? em.tool.note : "" ) }}</td>
                                                        </tr>
                                                        <tr v-if="em.tool && em.tool.history"  :key="(em.id ? em.id : em.code)">
                                                            <td>H: {{ (em.tool.history ? em.tool.history : "" ) }}</td>
                                                            <td>E: {{ (em.tool.exam ? em.tool.exam : "" ) }}</td>
                                                            <td>M: {{ (em.tool.mdm ? em.tool.mdm : "" ) }}</td>
                                                            <td>T: {{ (em.tool.time ? em.tool.time : "" ) }}</td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                            CPT(s)
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left">
                                                            Qty
                                                        </th>
                                                        <th class="text-left">
                                                            Code
                                                        </th>
                                                        <th class="text-left">
                                                            Mod(s)
                                                        </th>
                                                        <th class="text-left">
                                                            Billing Prov
                                                        </th>
                                                        <th class="text-left">
                                                            Secondary Prov
                                                        </th>
                                                        <th class="text-left">
                                                            Date Perf
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="cpt in encLogDetail.codes.cpt" :key="(cpt.id ? cpt.id : cpt.code)">
                                                        <td>{{ ( cpt.qty ? cpt.qty : "" ) }}</td>
                                                        <td>{{ (cpt.code ? cpt.code : "") }}</td>
                                                        <td>
                                                            <span v-if="cpt.mod"><span v-for="(mod,i) in cpt.mods" :key="mod">{{ mod }}{{(cpt.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                        <td>{{ (cpt.billing_provider ? getProviderDetail(cpt.billing_provider) : "") }}</td>
                                                        <td>{{ (cpt.secondary_provider ? getProviderDetail(cpt.secondary_provider) : "") }}</td>
                                                        <td>{{ (cpt.date_performed ? cpt.date_performed : "") }}</td>
                                                    </tr>
                                                </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="3">
                                                            DX(s)
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left">
                                                            Code
                                                        </th>
                                                        <!-- <th class="text-left">
                                                            Unsp
                                                        </th> -->
                                                        <th class="text-left">
                                                            Related CPT
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="dx in encLogDetail.codes.dx" :key="(dx.id ? dx.id : dx.code.code)">
                                                        <td>{{ (dx.code.description ? dx.code.description : "") }}</td>
                                                        <!-- <td class="text-center">{{ (dx.unspecified ? "X" : "") }}</td> -->
                                                        <td>{{ (typeof dx.related_cpt === 'object' && dx.related_cpt !== null ? "" : dx.related_cpt) }}</td>
                                                    </tr>
                                                </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-2">
                        <v-col cols="12">
                            <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                            CDI(s)
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-left">
                                            Qty
                                        </th>
                                        <th class="text-left">
                                            Area
                                        </th>
                                        <th class="text-left">
                                            Note
                                        </th>
                                        <th class="text-left">
                                            Nurse
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="cdi in encLogDetail.cdis" :key="cdi.area">
                                        <td>{{ ( cdi.qty ? cdi.qty : "" ) }}</td>
                                        <td>{{ ( cdi.area ? cdi.area : "" ) }}</td>
                                        <td>{{ ( cdi.note ? cdi.note : "" ) }}</td>
                                        <td>{{ ( cdi.nurse ? cdi.nurse : "" ) }}</td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-col cols="12">
                        <v-btn
                            color="primary"
                            :text="proMode"
                            :outlined="proMode"
                            block
                            style="border-radius:0"
                            @click="closeLogDetail"
                        >
                            CLOSE DETAIL
                        </v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import { mapGetters } from "vuex";
import DXAPI from "../components/DXAPI.vue";
import HCPCSAPI from "../components/HCPCSAPI.vue";
import SimplePDFViewer from "../components/SimplePDFViewer.vue";
import EnhancedDocViewer from "../components/EnhancedDocViewer.vue";
import broadcast from "../mixins/windowSync.js";
//import PDFJSViewer from '../components/PDFJSViewer.vue'
import { ulid } from 'ulid';
import {
  WORKSHEET_REQUEST_STATUS,
  isAcepToolEligible,
  resolveActiveDos,
  worksheetEntryLevel,
  buildWorksheetVersionRecord,
  upsertWorksheetVersion
} from "../services/activeWorksheet";
import { sanitizeWorksheetHtml } from "../services/worksheetHtml";

export default{
  name: 'SimpleEditor',
    mixins: [broadcast],
    components: { DXAPI, HCPCSAPI, ulid, SimplePDFViewer, EnhancedDocViewer, broadcast },
    data: function () {
      return {
        //tableData: this.$store.getters.encs, 
        facilityParam:this.$route.params.facilityName,
        rowHeight:0,
        cardHeight:0,
        search:'',
        activeEnc:{},
        activeDocs:[],
        encLogs:[],
        encLogSearch:"",
        logHeaders:[
            { text: 'Log Time', value: 'change_time' },
            { text: 'User', value: 'user' },
            { text: 'Status', value: 'status' },
            { text: 'View Detail', value: 'view', align: 'center' }
        ],
        saving:false,
        //date: new Date().toISOString().substr(0, 10),
        menuacc: false,
        menu: false,
        modal: false,
        menu2: [false],
        deficientdialog: false,
        notesdialog: false,
        noteListDialog: false,
        logdetaildialog: false,
        selectedLog:{},
        encLogDetail:{},
        activeQaEnc:{},
        logdetaildostab:"",
        newnote:{
            note_type:"Internal",
            note:""
        },
        qanotein:{},
        newDef:{},
        defAdded:false,

        emToolPro:{},
        emToolACEP:[],
        // True only while openRow() is hydrating this encounter's saved ACEP
        // selections. The emToolACEP watcher is deep and fires on that
        // programmatic assignment exactly as it does on a real user pick, so
        // without this flag opening an encounter would look like an edit.
        acepHydrating:false,

        // Encounter-open race guard. Every openRow() takes the next generation
        // and remembers which encounter it asked for; a GET that completes
        // after a newer open, or one that answers for a different encounter,
        // applies nothing. The token is carried onward into the GETs that open
        // starts — the log list and the QA snapshot — because a guard that
        // stopped at the encounter GET still let a stale open write one
        // patient's QA comparison over another's chart. encLoadAttempt is what
        // retryEncounterLoad() reopens.
        encOpenGeneration: 0,
        encLoadError: "",
        encLoadAttempt: null,

        loadedPDF:"",
        pdfOpen:true,
        splitView:false,
        svTableHeight:"",

        qaEnc: false,
        readonly: false,
        encValid: false,
        //fieldRule:[(v) => !!v || 'Field Required to QA/Complete'],
        fieldRule: function(v,f){
            let out = true;
            if(this.reqCheck(f) && !v){
                out = 'Field Required to QA/Complete';
            }else{
            }
            return [out];
        },
        fieldRuleDep: function(v,f,df){
            let out = true;
            if(df && this.reqCheck(f) && !v){
                out = 'Field Required to QA/Complete';
            }else{
            }
            return [out];
        },
        fieldRuleInd: function(v,f,ind){
            let fArr = f.split("_"),
                fComb = fArr[0] + "_" + ind + "_" + fArr[1];
            let out = true;
            if(this.reqCheck(fComb) && !v.code){
                out = 'Field Required to QA/Complete';
            }else{
            }
            return [out];
        },
        broadcastDocsOpen: false,

        descriptionLimit: 50,
        entries: [],
        isLoading: false,
        model: null,
        searchAPI:null,

        secondEM: false,
        dxchange: 0,
        hcpcschange: 0,
        emchange: 0,
        cptchange: 0,
        cdichange: 0,
        defchange: 0,

        sortStatus:"",
        statuses:["","NEW","IN PROGRESS", "INCOMPLETE", "QA", "COMPLETE", "DEFICIENT"],
        codeListHeaders:[
            {
            text: 'Status',
            align: 'start',
            sortable: true,
            value: 'status',
            width:'20%'
            },
            { text: 'DOS', value: 'dos',width:'16%' },
            { text: 'FIN', value: 'ext_id',width:'20%' },
            { text: 'Name', value: 'demographics.lastName',width:'22%' },
            //{ text: 'First Name', value: 'demographics.firstName' },
            // { text: 'Gender', value: 'demographics.gender' },
            // { text: 'DOB', value: 'demographics.dob' },
            {
                text: "Notes  |  View  |  Edit",
                value: "buttons",
                sortable: false,
                align: "center",
                width: "20%"
            },
            // {
            //     text: "Notes",
            //     value: "noteButton",
            //     sortable: false,
            //     align: "center",
            //     width: "8%"
            // },
            // {
            //     text: "View",
            //     value: "viewButton",
            //     sortable: false,
            //     align: "center",
            //     width: "8%"
            // },
            // {
            //     text: "Edit",
            //     value: "loadButton",
            //     sortable: false,
            //     align: "center",
            //     width: "8%"
            // }
        ],
        codeListHeadersSplit:[
            {
            text: 'Status',
            align: 'start',
            sortable: true,
            value: 'status',
            width:'25%'
            },
            { text: 'DOS', value: 'dos',width:'20%' },
            { text: 'FIN', value: 'ext_id',width:'25%' },
            // { text: 'Name', value: 'demographics.lastName',width:'22%' },
            {
                text: "Notes  |  View  |  Edit",
                value: "buttons",
                sortable: false,
                align: "center",
                width: "30%"
            },
            // {
            //     text: "",
            //     value: "viewButton",
            //     sortable: false,
            //     align: "center",
            //     width: "8%"
            // },
            // {
            //     text: "",
            //     value: "loadButton",
            //     sortable: false,
            //     align: "center",
            //     width: "8%"
            // }
        ]
      }
    },
    computed: {
        ...mapGetters(["wsUps","encs","sortStatuses","encPDF","facility","client","encountersUpdatedInit","emToolProLT","proMode"]),
        facilities(){
            return this.$store.getters.facilities;
        },
        relCPT(){
            let out = [], cpts = this.activeEnc.codes.cpt;
            for(let c=0; c<cpts.length; c++){
                out.push(
                    cpts[c].code + "_" + cpts[c].date_performed + "_" + cpts[c].billing_provider
                )
            }
            return out;
        },
      // Facility eligibility for the ACEP tool goes through the shared
      // predicate rather than facTools.indexOf(): a missing or non-array
      // facSettings.tools must mean "not eligible", not a TypeError thrown out
      // of this render or out of encounter hydration.
      acepToolEnabled(){
        return isAcepToolEligible(this.$store.getters.facTools);
      },
      // The ACEP catalog is encounter-scoped now and is emptied on every
      // failure, so binding the picker straight to it would hide saved chips:
      // Vuetify resolves what it renders from `items`, not from the bound
      // value, and drops any selection it cannot find there. Carry the current
      // selections the resolved worksheet does not describe so historical
      // choices stay visible. They are not newly selectable: an entry leaves
      // this list as soon as it is deselected.
      acepPickerItems(){
        let choices = this.$store.getters.acepToolChoices,
            items = (Array.isArray(choices) ? choices.slice() : []),
            selected = (Array.isArray(this.emToolACEP) ? this.emToolACEP : []),
            // Identity is acepItemValue(), the same key the picker's
            // :item-value gives Vuetify, so this list and Vuetify's own
            // filterDuplicates()/setSelectedItems() agree on what "already
            // described" means. Keying on description instead would let a
            // current entry stand in for a saved selection that merely shares
            // its text, and would drop the saved chip whose id is not in the
            // resolved catalog.
            seen = [],
            key;
        for(let i=0; i<items.length; i++){
            key = this.acepItemValue(items[i]);
            if(key){
                seen.push(key);
            }
        }
        for(let s=0; s<selected.length; s++){
            if(!selected[s]){
                continue;
            }
            key = this.acepItemValue(selected[s]);
            // An identity-less selection (neither id nor description) matches
            // nothing, so it is carried rather than silently dropped: Vuetify
            // renders only what it finds in `items`, so leaving it out makes a
            // saved chip vanish from the picker while it is still in the model
            // and still persisted. Same rule as EnhancedEditor.
            if(key && seen.indexOf(key) != -1){
                continue;
            }
            if(key){
                seen.push(key);
            }
            items.push(selected[s]);
        }
        return items;
      },
      // Vuetify shows this both when the list is empty and when a search
      // matches nothing, which are different facts. Saying "none for this date
      // of service" over a healthy worksheet would be a lie.
      acepPickerNoDataText(){
        return (this.acepPickerItems.length
            ? "No matching interventions."
            : "No interventions are available for this date of service.");
      },
      items () {
        return this.entries.map(entry => {
          const Description = entry.code + " - " + (entry.name.length > this.descriptionLimit
            ? entry.name.slice(0, this.descriptionLimit) + '...'
            : entry.name)

          return Object.assign({}, entry, { Description })
        })
      },
    },
    watch:{
      encPDF(docLink){
          if(this.broadcastDocsOpen){
              this.sendMessage("patientDoc", docLink);
          }
      },
      emToolPro:{
          handler: function(){
            // console.log("EM TOOL PRO LT change");
            this.calculateEmToolPro();
          },
          deep:true
      },
      emToolACEP:{
          handler: function(tool){
              // Opening an encounter assigns its saved selections here, and a
              // deep watcher cannot tell that apart from a user pick. Only the
              // consequences of a real edit are gated: the derived code is
              // still recalculated from hydrated selections exactly as before,
              // but hydration may neither clear a saved code nor stamp
              // worksheet provenance onto selections it did not create.
              let hydrating = this.acepHydrating;
              if(!this.activeEnc || !this.activeEnc.codes || !this.activeEnc.codes.em || !this.activeEnc.codes.em[0]){
                  return;
              }
              if(tool.length>0){
                //// console.log("EM TOOL ACEP LT change");
                //this.activeEnc.codes.em[0].code = tool[tool.length-1].level;
                //// console.log(JSON.stringify(tool));
                // Math.max over a selection whose level is missing or
                // non-numeric is NaN, and NaN.toString() would be persisted as
                // the E/M code "NaN". The response validator now rejects such
                // an entry, but a selection saved before this migration can
                // still carry a bad level, so only usable levels are allowed to
                // derive the code. A selection with none of them leaves the
                // derived code alone — a coder-entered code is not destroyed by
                // data the calculation cannot read — while tool.selected below
                // still persists exactly what is selected.
                let levels = [];
                for(let t=0; t<tool.length; t++){
                    let entrylevel = worksheetEntryLevel(tool[t]);
                    if(!isNaN(entrylevel)){
                        levels.push(entrylevel);
                    }
                }
                if(levels.length>0){
                    let highestlevel = Math.max.apply(Math,levels).toString();
                    // // console.log(highestlevel);
                    if(highestlevel == "99292"){
                        //// console.log("ADDING 2 EMs");
                        this.activeEnc.codes.em[0].code = "99291"
                        if(!this.secondEM){
                            this.secondEM = true;
                            this.addRow("em",0,null);
                        }
                    }else if(highestlevel == "99291"){
                        //// console.log("NO SECOND EM");
                        this.activeEnc.codes.em[0].code = "99291"
                        if(this.secondEM){
                            this.secondEM = false;
                            this.deleteRow("em",1,null)
                        }
                    }else{
                        this.activeEnc.codes.em[0].code = highestlevel;
                        this.checkCode(this.activeEnc.codes.em[0].code,false);
                    }
                }
                this.activeEnc.codes.em[0].tool.selected = tool;
              }else if(!hydrating){
                // Removing the last chip used to fall off the end of this
                // handler, leaving the previous selection, the derived code and
                // any auto-added critical-care row in activeEnc for the next
                // full save to persist. Clearing the code to "" was confirmed
                // in Gate 0b.
                this.activeEnc.codes.em[0].code = "";
                if(this.secondEM){
                    this.secondEM = false;
                    this.deleteRow("em",1,null)
                }
                let emptied = this.activeEnc.codes.em[0];
                if(emptied.tool){
                    emptied.tool.selected = [];
                }else{
                    this.$set(emptied,"tool",{selected:[],note:""});
                }
              }
              if(!hydrating){
                // Same update path that writes tool.selected, so the selection
                // and its provenance cannot drift apart.
                this.applyACEPWorksheetProvenance();
              }
          },
          deep:true
      },
      activeDocs:{
          handler: function(docs){
            if(this.broadcastDocsOpen){
                // console.log("AD CHANGE: " + JSON.stringify(docs));
                this.sendMessage("patientDoc", docs);
            }
          },
          deep:true
      },
      //update table if data changes
      sortStatus(status){
        //   // console.log("SORTING: " + this.$store.getters.origEncs[this.facility].length);
        //   let sortable = [...this.$store.getters.origEncs[this.facility]]
          if(status == 'My QA Reviewed'){
              this.encs[this.facility] = this.$store.getters.origEncs[this.facility].filter(enc => enc.qa_user == this.$store.getters.username);
          }else if(status){
              this.encs[this.facility] = this.$store.getters.origEncs[this.facility].filter(enc => enc.status == status);
          }else{
              this.encs[this.facility] = this.$store.getters.origEncs[this.facility].filter(enc => enc.status != 'EXPORT');
          }
          
      },
      encountersUpdatedInit(){
          if(this.$store.getters.origEncs[this.facility]){
              this.encs[this.facility] = this.$store.getters.origEncs[this.facility].filter(enc => enc.status != 'EXPORT');
          }
      },
      tableData:{
        handler: function (newData) {
          // console.log("CHANGES TO TABLE")
        },
        deep: true,
      },
    //   deficientdialog (val){
    //     //   // console.log(this.$refs.encform)
    //       if(val){
    //           if(this.activeEnc.deficients.length == 0){
    //               this.addRow("deficient",0,this.activeEnc.encid);
    //           }
    //       }
    //   },
      searchAPI (val) {
        // Items have already been loaded
        //if (this.items.length > 0) return
        if (val && val.length > 15) return
        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        // Lazily load input items
        fetch('https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms='+val)
          .then(res => res.json())
          .then(res => {
              let resarr = res[3],rlen=resarr.length,entries=[];
            for(let r=0; r<rlen; r++){
                entries.push({
                    name: resarr[r][1],
                    code: resarr[r][0],
                })
            }
            this.count = rlen
            this.entries = entries
          })
          .catch(err => {
             console.log(err)
          })
          .finally(() => (this.isLoading = false))
      },
      facilities(newf,oldf){
          // console.log("NEW FACILITIES INCOMING");
          if(newf!=oldf){
              this.loadFac();
          }
      }
    },
    mounted(){
        // console.log("FAC: " + this.facilityParam);
        // console.log("FACILITIES LENGTH: " + Object.keys(this.facilities).length);
        if(this.facilities[this.facilityParam]){
            this.loadFac();
        }else{
            // console.log("NO FACILITIES YET, WE MUST WAIT");
        }
        // if(!this.$store.getters.facilityName){
        //     this.$store.dispatch("updateFacClient",{
        //         facility:this.facilities[this.facility].facility_display_name,
        //         client:this.facilities[this.facility].client_display_name
        //     })
        // }
      //this.tableData = this.$store.getters.encs;
    
    // console.log("VH: " + this.$root.vhNum);
    this.rowHeight = this.$root.vhNum-275;
    this.cardHeight = this.$root.vhNum-385;
    this.svTableHeight = this.$root.vhNum-105 + "px";
    },
    methods:{
        modStringer(mods){
            let out = "";
            for(let m=0; m<mods.length; m++){
                out += mods[m] + (mods.length != m+1 ? ", " : "");
            }
            return out;
        },
        loadFac(){
            // console.log("LOAD FACILITY");
            this.$store.dispatch("updateFac",this.facilityParam).then(()=>{
                this.$store.dispatch("updateClient",this.facilities[this.facilityParam].client);
                this.$store.dispatch("updateFacSettings").then(()=>{
                    // console.log("FAC LOADED view");
                    this.$store.dispatch("updateFacClient",{
                        facility:this.facilities[this.facility].facility_display_name,
                        client:this.facilities[this.facility].client_display_name
                    });
                    this.$store.dispatch("updateEncountersFac");
                    this.$store.dispatch("updateProviders");
                    this.$store.dispatch("updateCodesAll");
                    this.$store.dispatch("updateDXs");
                    this.$store.dispatch("updateMods");
                    // The ACEP catalog is no longer facility-scoped: it is
                    // resolved per coding encounter in openRow(), for that
                    // encounter's facility and date of service.
                    this.activeDocs = [{
                        dockey:"dummy.pdf",
                        name:"dummy.pdf",
                        type:"pdf"
                    }];
                    //this.$store.dispatch("updateEncPDF","dummy.pdf");
                    if(this.$store.getters.origEncs[this.facility]){
                        this.encs[this.facility] = this.$store.getters.origEncs[this.facility].filter(enc => enc.status != 'EXPORT');
                    }
                    
                    let encid = this.$route.query.encid;
                    //let ext_id = this.$route.query.ext_id;
                    // console.log(encid);
                    if(encid){
                        // console.log("LOAD IT UP FROM QUERY")
                        this.openRow({
                            encid:encid,
                            status:null
                        },true);
                    }
                });
            });
        },
        dxValid(ind){
            let fComb = "DX_" + ind + "_code";
            let out = false;
            if(this.reqCheck(fComb)){
                //// console.log(ind + " DX REQUIRED!");
                //// console.log("VALUE: " + JSON.stringify(this.activeEnc.codes.dx[ind].code));
                if(this.activeEnc.codes.dx[ind].code == "" || !this.activeEnc.codes.dx[ind].code.code){
                    out = false;
                }else{
                    out = true;
                }
            }else{
                out = true
            }
            return out;
        },
        // The QA comparison label dereferences the last selected intervention.
        // With nothing selected that element is undefined and the render throws,
        // freezing the editor exactly when the last chip is removed — now a
        // supported action. undefined is returned for an empty set so the
        // comparison still resolves to the mismatch marker.
        acepLastDescription(selected){
            let list = (Array.isArray(selected) ? selected : []);
            return (list.length && list[list.length-1] ? list[list.length-1].description : undefined);
        },
        // The QA side of the same comparison. It walked
        // qa.codes.em[0].tool.selected[...] inline, which throws during render
        // for any snapshot that is missing a piece of that chain — no codes, no
        // em row, a tool object with no selected array — and a throw in a
        // render freezes the editor. Total, and always an array, so the label
        // below can be written as one expression.
        acepQaSelected(qa){
            if(!qa || !qa.codes || !qa.codes.em || !qa.codes.em[0] || !qa.codes.em[0].tool){
                return [];
            }
            let selected = qa.codes.em[0].tool.selected;
            return (Array.isArray(selected) ? selected : []);
        },
        // The whole picker label, so no part of the comparison is evaluated in
        // the template. Output is unchanged for every input that did not throw
        // before: "Description" when there is nothing to compare against,
        // otherwise the QA description and the match marker.
        acepPickerLabel(qa,selected){
            if(!this.qaEnc){
                return "Description";
            }
            let qaSelected = this.acepQaSelected(qa),
                qaLast = (qaSelected.length ? qaSelected[qaSelected.length-1] : null);
            if(!qaLast){
                return "Description";
            }
            return "Desc: " + qaLast.description +
                (qaLast.description == this.acepLastDescription(selected) ? " - ✓" : " - ✗");
        },
        // Stable identity for one intervention, used by the picker's
        // :item-value and by the acepPickerItems merge so both agree.
        //
        // Vuetify 2.3.10 has no default value field here: getValue() is
        // getPropertyFromItem(item, itemValue, getText(item)), and both
        // filterDuplicates() and setSelectedItems() key off it. Without an
        // item-value that means the description is the identity, so two service
        // entries with different ids and the same description collapse into one
        // row, and a saved selection can be silently substituted by a current
        // entry that merely shares its text. The description is kept as the
        // fallback because selections saved before entries had an id have
        // nothing else, and returning undefined for a missing item lets
        // Vuetify's own text fallback take over.
        acepItemValue(item){
            if(item && typeof item.id === "string" && item.id){
                return item.id;
            }
            return (item ? item.description : undefined);
        },
        // additional_info is authored rich HTML that now arrives from a dynamic
        // service and is rendered with v-html, so it is reduced to a
        // formatting-only allowlist first. The sanitizer fails closed to
        // escaped text, so an unusable purifier cannot become a raw injection.
        acepAdditionalInfo(item){
            return sanitizeWorksheetHtml(item && item.additional_info);
        },
        // One explicit policy for an encounter GET that rejected, or that
        // answered for an encounter nobody asked for. Leaving the previous
        // patient on screen under the row the coder just clicked is the failure
        // that matters here, so this clears back to no active encounter. The
        // open never happened: no encounter status is written and browser
        // history is not rewritten, and the error is retryable.
        encLoadFailed(){
            // activeEnc first: the assignments below can queue the deep
            // emToolACEP watcher, which must see an encounter it refuses to
            // touch rather than a half-cleared one.
            this.activeEnc = {};
            this.activeQaEnc = {};
            this.qaEnc = false;
            this.acepHydrating = false;
            this.emToolACEP = [];
            this.secondEM = false;
            // The dummy document, never an empty array: the doc viewer is bound
            // with :key="activeDocs[0].dockey" and is only v-show'd, so it is
            // evaluated on every render. Emptying the list throws out of the
            // render, Vue keeps the last good vnode, and the failure message and
            // Retry below would never appear at all -- the previous patient would
            // stay frozen on screen, which is exactly the failure this policy
            // exists to prevent. Every other clear site in this file does the
            // same thing.
            this.activeDocs = [{
                dockey:"dummy.pdf",
                name:"dummy.pdf",
                type:"pdf"
            }];
            this.encLogs = [];
            this.encLogDetail = {};
            this.$store.dispatch("updateActiveEncId",null);
            // resetACEPTool is not dispatched again: openRow() already did so
            // before this GET, no worksheet was resolved for a request that
            // never produced an encounter, and the dispatch is destructive.
            this.encLoadError = "This encounter could not be opened. Nothing was changed.";
        },
        // A transient failure should cost one click, not a return trip through
        // the encounter list, so the row and mode the failed attempt asked for
        // are reopened as they were.
        retryEncounterLoad(){
            let attempt = this.encLoadAttempt;
            if(!attempt || !attempt.row){
                return;
            }
            this.encLoadError = "";
            this.openRow(attempt.row,attempt.readonly);
        },
        // Persist which worksheet version this encounter's ACEP selection set
        // was edited under. The metadata is only staged when the encounter
        // loads; it becomes encounter data here, on a real selection change,
        // and reaches the backend with the next full save. Opening an encounter
        // therefore never attributes a pre-migration selection to a worksheet
        // that merely happened to resolve while it was on screen.
        applyACEPWorksheetProvenance(){
            let staged = this.$store.getters.acepToolRequest;
            // READY is the sole discriminator. A request key repeats for the
            // same encounter and DOS, so comparing keys cannot detect a
            // superseded completion, and a non-null worksheet alone is not
            // enough either.
            if(!staged || staged.status !== WORKSHEET_REQUEST_STATUS.READY || !staged.worksheet){
                return;
            }
            let enc = this.activeEnc;
            if(!enc || !enc.encid){
                return;
            }
            // A viewed encounter is not an edited one. The form is disabled in
            // this mode, so a watcher fire here can only be programmatic.
            if(this.readonly){
                return;
            }
            // Reconfirm the staged context still describes the encounter being
            // edited, not one resolved for a previous open.
            if(staged.encounterId !== enc.encid || staged.client !== enc.client || staged.facility !== enc.facility){
                return;
            }
            // The other half of the composite key. Compare normalized values;
            // never re-derive the date, so the DOS that was requested and the
            // DOS that is persisted cannot diverge.
            if(resolveActiveDos(enc) !== staged.normalizedDos){
                return;
            }
            // $set because a pre-migration encounter has no worksheet_versions
            // key at all, and Vue 2 cannot observe one added by assignment.
            this.$set(
                enc,
                "worksheet_versions",
                upsertWorksheetVersion(enc.worksheet_versions,buildWorksheetVersionRecord(staged.normalizedDos,staged.worksheet))
            );
        },
        reqCheck(field){
            let out = false;
            if(this.$store.getters.requiredFields.indexOf(field)>=0){
                out = true;
            }
            //// console.log("REQ CHECK: " + field + ": " + out);
            return out;
        },
        calculateEmToolPro(){
            // console.log(JSON.stringify(this.emToolPro));
            let facType = "ER",
                tval = this.emToolProLT.time.indexOf(this.emToolPro.time),
                vals=[{area:"history",value:0},{area:"exam",value:0},{area:"mdm",value:0}],hemtot;
            this.activeEnc.codes.em[0].tool = this.emToolPro;           

            if(facType == "ER"){
                if(tval>0){
                    this.activeEnc.codes.em[0].code = "99291";
                    if(this.activeEnc.codes.em[0].downcode){
                        this.activeEnc.codes.em[0].downcode = false;
                        this.deleteRow('dc',0,this.activeEnc.encid);
                    }
                    if(tval>1){
                        if(!this.secondEM){
                            this.secondEM = true;
                            this.addRow("em",0,null);
                        }
                        this.activeEnc.codes.em[1].qty = tval-1;
                        this.activeEnc.codes.em[1].tool = this.emToolPro;
                    }else if(this.secondEM){
                        this.secondEM = false;
                        this.deleteRow("em",1,null)
                    }
                }else{
                    let codes = ["","99281","99282","99283","99284","99285"];
                    vals[0].value = (this.emToolProLT.history.indexOf(this.emToolPro.history) > 0 ? this.emToolProLT.history.indexOf(this.emToolPro.history) + 2 : 1);
                    vals[1].value = (this.emToolProLT.exam.indexOf(this.emToolPro.exam) > 0 ? this.emToolProLT.exam.indexOf(this.emToolPro.exam) + 2 : 1);
                    vals[2].value = this.emToolProLT.mdm.indexOf(this.emToolPro.mdm) + 1;
                    // console.log("H: " + vals[0].value + " | E: " + vals[1].value + " | M: " + vals[2].value);
                    if(vals[0].value >= vals[2].value && vals[1].value >= vals[2].value){
                        this.activeEnc.codes.em[0].code = codes[vals[2].value];
                        this.activeEnc.codes.em[0].downcode = false;
                        this.deleteRow('dc',0,this.activeEnc.encid);
                    }else{
                        let lowest = vals.reduce((min, p) => p.value < min.value ? p : min, vals[0]);
                        this.activeEnc.codes.em[0].code = codes[lowest.value];
                        // console.log("LOWEST: " + JSON.stringify(lowest));
                        if(!this.activeEnc.codes.em[0].downcode){
                            this.activeEnc.codes.em[0].downcode = true;
                            this.addRow('dc',-1,this.activeEnc.encid,true);
                        }
                    }
                    this.checkCode(this.activeEnc.codes.em[0].code,false);
                }
            }
        },
        toggleDowncode(){
            if(this.activeEnc.codes.em[0].downcode){
                this.addRow('dc',-1,this.activeEnc.encid,true);
            }else{
                this.deleteRow('dc',0,this.activeEnc.encid);
            }
        },
        togglePDF(){
            // console.log("PDF OPEN: " + this.pdfOpen);
            this.pdfOpen = !this.pdfOpen;
            this.splitView = false;
            // console.log("OPEN WINDOW? " + this.pdfOpen);
            if(!this.pdfOpen){
                this.broadcastDocs();
            }
        },
        broadcastDocs() {
            // this.createChannel("patientDoc", "PopoutPDFViewer", 800, 600, {
            //     fname: this.encPDF,
            // });
            this.createChannel("patientDoc", "EnahncedPopoutPDFViewer", 800, 600, {
                facility: this.facility,
                client: this.client,
                activeDocs: JSON.stringify(this.activeDocs)
            });
            this.broadcastDocsOpen = true;
        },
        toggleSplitView(){
            // console.log("SPLIT VIEW OPEN: " + this.splitView);
            this.splitView = !this.splitView;
        },
        // cpt:{"code": "","description": "","mods": [],"qty": 1,"date_performed": "","billing_provider": "","secondary_provider": ""},
        // dx:{"code": "","description": "","unspecified": false,"related_cpt": {"code": "","billing_provider": "","date_performed": ""}},
        // cdi:{"area": "","qty": 1,"nurse": "","note": ""}
        deleteRow(type,ind,encid){
            // console.log(type + " | " + ind + " | " + encid);
            let d = new Date().getTime();
            switch(type){
                case "em":
                    if(this.activeEnc.codes.em.length == 1){
                        this.activeEnc.codes.em[0] =  {"id":ulid(),"code": "","description": "","mods": [],"billing_provider": "","secondary_provider": ""};
                    }else{
                        this.activeEnc.codes.em.splice(ind, 1)
                    } 
                    this.emchange++;
                    break;
                case "cpt":
                    if(this.activeEnc.codes.cpt.length == 1){
                        this.activeEnc.codes.cpt[0] =  {"id":ulid(),"code": "","description": "","mods": [],"qty": 1,"date_performed": "","billing_provider": "","secondary_provider": ""};
                    }else{
                        this.activeEnc.codes.cpt.splice(ind, 1)
                    } 
                    this.cptchange++;
                    break;
                case "hcpcs":
                    if(this.activeEnc.codes.hcpcs.length == 1){
                        this.activeEnc.codes.hcpcs[0] = {"id":ulid(),"code": {"description":null,"code":null},"description": "","mods": [],"qty": 1,"billing_provider": "","secondary_provider": ""};
                    }else{
                        this.activeEnc.codes.hcpcs.splice(ind, 1)
                    } 
                    this.hcpcschange++;
                    break;
                case "dx":
                    if(this.activeEnc.codes.dx.length == 1){
                        this.activeEnc.codes.dx[0] = {"id":ulid(),"code": {"description":null,"code":null},"description": "","unspecified": false,"related_cpt": {"code": "","billing_provider": "","date_performed": ""}};
                    }else{
                        this.activeEnc.codes.dx.splice(ind, 1)
                    } 
                    this.dxchange++;
                    break;
                case "cdi":
                    if(this.activeEnc.cdis.length == 1){
                        this.activeEnc.cdis[0] = {"area": "","qty": 1,"nurse": "","note": ""};
                    }else{
                        this.activeEnc.cdis.splice(ind, 1)
                    } 
                    this.cdichange++;
                    break;
                case "dc":
                    this.activeEnc.downcodes.splice(ind, 1)
                    break;
                case "deficient":
                    if(this.activeEnc.deficients.length == 1){
                        this.activeEnc.deficients[0] = {"deficient_reason":"","provider":"","note":"","user":this.$store.getters.username,"time":d};
                    }else{
                        this.activeEnc.deficients.splice(ind, 1)
                    } 
                    this.defchange++;
                    break;
            }
        },
        addRow(type,ind,encid){
            let d = new Date().getTime();
            // console.log(type + " | " + ind + " | " + encid);
            switch(type){
                case "em":
                    this.activeEnc.codes.em.splice(ind + 1, 0, {"id":ulid(),"code": "99292","description": "","mods": [],"billing_provider": (this.activeEnc.codes.em[0].billing_provider ? this.activeEnc.codes.em[0].billing_provider : ""),"secondary_provider": (this.activeEnc.codes.em[0].secondary_provider ? this.activeEnc.codes.em[0].secondary_provider : ""),"qty":1});
                    this.emchange++;
                    break;
                case "cpt":
                    this.activeEnc.codes.cpt.splice(ind + 1, 0, {"id":ulid(),"code": "","description": "","mods": [],"qty": 1,"date_performed": (this.activeEnc.dos ? new Date(this.activeEnc.dos).toISOString().substr(0, 10) : ""),"billing_provider": (this.activeEnc.codes.em[0].billing_provider ? this.activeEnc.codes.em[0].billing_provider : ""),"secondary_provider": (this.activeEnc.codes.em[0].secondary_provider ? this.activeEnc.codes.em[0].secondary_provider : "")});
                    this.cptchange++;
                    break;
                case "hcpcs":
                    this.activeEnc.codes.hcpcs.splice(ind + 1, 0, {"id":ulid(),"code": {"description":null,"code":null},"description": "","mods": [],"qty": 1,"billing_provider": "","secondary_provider": ""});
                    this.hcpcschange++;
                    break;
                case "dx":
                    this.activeEnc.codes.dx.splice(ind + 1, 0, {"id":ulid(),"code":  null,"description": "","unspecified": false,"related_cpt": {"code": "","billing_provider": "","date_performed": ""}});
                    this.dxchange++;
                    break;
                case "cdi":
                    this.activeEnc.cdis.splice(ind + 1, 0, {"area": "","qty": 1,"nurse": "","note": ""});
                    this.cdichange++;
                    break;
                case "dc":
                    this.activeEnc.downcodes.splice(ind + 1, 0, {"area": "","qty": 1,"nurse": "","note": "","downcode":true});
                    break;
                case "deficient":
                    this.activeEnc.deficients.splice(ind + 1, 0, {"deficient_reason":"","provider":"","note":"","user":this.$store.getters.username,"time":d});
                    this.defchange++;
                    break;
            }              
        },
        // moveRow('dx',dxind,'up'){
        moveRow(type,ind,dir){
            //// console.log(type + " | " + ind + " | " + dir);
            let c = this.activeEnc.codes[type].splice(ind,1)[0];
            switch(dir){
                case "up":
                    this.activeEnc.codes[type].splice(ind - 1, 0, c);
                    break;
                case "down":
                    this.activeEnc.codes[type].splice(ind + 1, 0, c);
                    break;
            }
            this.dxchange++;
        },
        checkCode(code,override){
            // console.log("CHECKING CODE: " + code);
            if(code == "99291" && !this.secondEM){
                this.secondEM = true;
                this.addRow("em",0,null);
            }else if(code == "99291" && this.secondEM){
                // console.log("ALREADY SECOND EM TRUE");
            }else if(this.secondEM && !override){
                this.secondEM = false;
                this.deleteRow("em",1,null)
            }
        },
        allCapArray(arr){
            //// console.log("IN: " + JSON.stringify(arr));
            for(let a=0; a<arr.length; a++){
                arr[a] = arr[a].toString().toUpperCase().replace(/\s+/g, '');
                let ind = arr.indexOf(arr[a]);
                //// console.log("IND: " + ind);
                //// console.log("A: " + a);
                if(ind != -1 && ind != a){
                    //arr.splice(a,1);
                    arr.splice(ind,1);
                }
            }
            let out = [...new Set(arr)]
            //// console.log("OUT: " + JSON.stringify(out));
            return out;
        },
        objToValue(val,field){
            if(val[field]){
                return val[field];
            }else{
                return val;
            }
        },
        saveNote(){
            this.saving= true;
            this.newnote.user = this.$store.getters.username;
            this.newnote.time = new Date().getTime();
            
            this.activeEnc.notes = [...this.activeEnc.notes,...[this.newnote]];

            //// console.log("SAVING NOTE: " + JSON.stringify(this.newnote));

            this.postData(
            "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.activeEnc.facility + "/" + this.activeEnc.encid,this.activeEnc
            ).then((response) => {
                //// console.log(response);
                this.saving = false;
                this.newnote = {
                    note_type:"Internal",
                    note:""
                };
            });
        },
        addDef(){
            this.saving= true;
            this.newDef.user = this.$store.getters.username;
            this.newDef.time = new Date().getTime();
            
            this.activeEnc.deficients = [...this.activeEnc.deficients,...[this.newDef]];

            //// console.log("SAVING NOTE: " + JSON.stringify(this.newnote));

            this.postData(
            "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.activeEnc.facility + "/" + this.activeEnc.encid,this.activeEnc
            ).then((response) => {
                //// console.log(response);
                this.saving = false;
                this.newDef = {};
                this.defAdded = true;
            });
        },
        save(status){
            this.saving= true;
            if(status != "IN PROGRESS"){
                this.$store.dispatch("updateActiveEncId",null); 
            }
            //// console.log(status);
            this.deficientdialog = false;
            this.activeEnc.status = status;
            if(status == "QA"){
                this.activeEnc.qa_user = this.$store.getters.username;
                this.activeEnc.qa_diff = null;
            }
            if(this.qaEnc && status == "COMPLETE"){
                this.activeQaEnc.status = "COMPLETE";
                if(!this.shallowEqual(this.activeQaEnc,this.activeEnc,["discharge_disposition","accident_date"])){
                    // console.log("SHALLOW NOT EQUAL");
                    this.activeEnc.qa_diff = true;
                }else if(!this.deepEqual(this.activeQaEnc.codes,this.activeEnc.codes)){
                    // console.log("CODE NOT EQUAL");
                    this.activeEnc.qa_diff = true;
                }else if(!this.deepEqual(this.activeQaEnc.cdis,this.activeEnc.cdis)){
                    // console.log("CDI NOT EQUAL");
                    this.activeEnc.qa_diff = true;
                }else{
                    // console.log("ALL EQUAL");
                    this.activeEnc.qa_diff = false;    
                }
                // console.log("QA DIFF? " + this.activeEnc.qa_diff);

                if(this.activeEnc.qa_notes[0] && this.activeEnc.qa_notes[0].note){
                    if(this.qanotein != this.activeEnc.qa_notes[0].note){
                        this.activeEnc.qa_notes[0].user = this.$store.getters.username;
                        this.activeEnc.qa_notes[0].time = new Date().getTime();
                    }
                }else{
                    this.activeEnc.qa_notes[0].user = this.$store.getters.username;
                    this.activeEnc.qa_notes[0].time = new Date().getTime();
                }
            }
            
            //// console.log(JSON.stringify(this.activeEnc));
            this.postData(
            "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.activeEnc.facility + "/" + this.activeEnc.encid,this.activeEnc
            ).then((response) => {
                // console.log("SAVE RES: " + JSON.stringify(response));
                if(status != "IN PROGRESS"){
                    this.activeEnc = {};
                    this.encLogs=[];
                    this.qaEnc = false;
                    this.activeQaEnc = {};
                    //this.$store.dispatch("updateEncPDF");
                    this.activeDocs = [{
                        dockey:"dummy.pdf",
                        name:"dummy.pdf",
                        type:"pdf"
                    }];
                    this.encLogDetail = {};
                    history.pushState(null, "", location.href.split("?")[0]);
                }
                this.saving = false;
                this.encValid = false;
            });
        },
        saveInP(status){
            this.saving= true;
            //// console.log(status);
            this.deficientdialog = false
            this.activeEnc.status = status;
            //// console.log(JSON.stringify(this.activeEnc));
            this.postData(
                "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.activeEnc.facility + "/" + this.activeEnc.encid + "/status",
                {status:"IN PROGRESS"}
            ).then((response) => {
                // console.log("INP RES: " + response);
                this.forceFormValidate("encform");
                this.saving = false;
            });
        },
        forceFormValidate(form){
            this.$refs[form].validate();
        },
        openNotesEncList: function(row){
            //// console.log(JSON.stringify(row));
            this.noteListDialog = true;
            this.getData(
                    "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.facility + "/" + row.encid
                ).then((response) => {
                    this.activeEnc = response;
                    
                    if(this.activeEnc.qa_notes && this.activeEnc.qa_notes[0]){
                        this.qanotein = this.activeEnc.qa_notes[0].note;
                    }else{
                        this.activeEnc.qa_notes = [{
                            note:"",
                            user: this.$store.getters.username,
                            time: new Date().getTime()
                        }];
                        this.qanotein = "";
                    }
                    
                    this.$store.dispatch("updateActiveEncId",response.encid);
                    this.notesdialog = true;
                });
        },
        closeNotes(){
            if(this.noteListDialog){
                this.activeEnc = {};
            }
            this.notesdialog=false 
            this.noteListDialog=false
        },
        closeDefs(){
            this.deficientdialog=false 
        },
        closeLogDetail(){
            this.logdetaildialog=false
            this.selectedLog = "";
            this.encLogDetail = {};
        },
        editOpen(){
            // this.readonly = false;
            // this.activeEnc.status = "IN PROGRESS";
            // this.saveInP('IN PROGRESS');
            if(this.activeEnc.status == "QA"){
                //this.qaEnc = true;
                //this.openLastQA();
                this.openRow(this.activeEnc,false);
            }else{
                this.openRow(this.activeEnc,false);
            }
        },
        openLastQA(generation){
            let logs = [...this.encLogs];
            logs.sort((a, b) => b.change_time - a.change_time);
            for(let l=0; l<logs.length; l++){
                if(logs[l].status == "QA"){
                    // Carried, not re-read from this.encOpenGeneration: the
                    // point of the token is to identify the open this call
                    // descends from, and reading the current value here would
                    // always match and guard nothing. Undefined when the caller
                    // had none, which leaves the request unguarded.
                    this.getLogDetail(logs[l].dockey,true,generation);
                    break;
                }
            }
        },
        openRow:function(row,readonly){
            this.readonly = readonly;
            let status = row.status;
            this.qaEnc = false;
            // The banner flag was cleared here, but the snapshot behind it was
            // not. So a QA reviewer who left A (status QA) for B (also QA) whose
            // getLogDetail never lands kept A in activeQaEnc under B's banner:
            // A's reviewer in the header, every "QA versus current" label
            // computed from A's chart against B's fields, and a Complete that
            // deep-compares A's codes and cdis to B's and persists qa_diff on B
            // from the wrong patient's basis. The flag and the snapshot it
            // describes are one piece of state, so both are cleared.
            //
            // Clearing the snapshot alone would have been a worse bug than the
            // one it fixed, because getLogs() used to raise qaEnc a hop before
            // the snapshot existed: "banner up, snapshot empty" would have
            // become permanent wherever the snapshot GET never lands, and that
            // state throws in the roughly thirty comparison labels task 7 did
            // not make total. Both writes are therefore in place: qaEnc now
            // rises in getLogDetail's forQA branch beside the activeQaEnc
            // assignment, so it is false for as long as this clear leaves the
            // snapshot empty, and there is no window in which the labels have a
            // banner to render against and nothing to read.
            //
            // Both editors are the same shape here now, which is the point:
            // "the QA banner is never up without a QA snapshot" is a structural
            // property of where the two writes live, not a defence bolted onto
            // the labels one at a time.
            this.activeQaEnc = {};
            // The previous encounter's audit trail used to stay on screen under
            // the row the coder just clicked: the History Logs table is v-if on
            // encLogs.length, this method assigned activeEnc and only then
            // started getLogs(), and that GET has no rejection handling — so
            // A's logs showed beneath B until B's landed, or forever if they
            // never did. Those rows open a detail dialog carrying MRN, name,
            // DOB and payer, so both are emptied before the GET starts.
            this.encLogs = [];
            this.encLogDetail = {};
            // Every open takes the next generation and remembers the encounter
            // it asked for. Two opens in a row can complete out of order, and
            // whichever GET finished last used to win: the coder clicks B, A's
            // delayed response arrives and A becomes the active encounter,
            // including its status write and its history entry. The worksheet
            // race guard cannot see this — it happens one layer earlier — so
            // both the generation and the returned encid are checked below.
            this.encOpenGeneration = this.encOpenGeneration + 1;
            let generation = this.encOpenGeneration,
                requestedEncid = row.encid;
            this.encLoadAttempt = {row:row,readonly:readonly};
            this.encLoadError = "";
            this.$store.dispatch("updateActiveEncId",null);
            // Switching coding encounters invalidates any in-flight worksheet
            // request and empties the catalog now, before the next encounter is
            // visible, so the previous encounter's interventions can never be
            // selectable against this one. Only this coding-open path may do
            // this; a notes-only view would discard a legitimate resolution.
            this.$store.dispatch("resetACEPTool");
            this.getData(
                    "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.facility + "/" + row.encid
                ).then((response) => {
                    //// console.log(response);
                    if(generation !== this.encOpenGeneration){
                        // A newer open owns the editor. Applying anything here
                        // would put this encounter's patient back on screen and
                        // rewrite the active id, the history entry and the
                        // status behind the coder's back, so this completion
                        // applies nothing at all and reports nothing either:
                        // the newer open is responsible for what is displayed.
                        return;
                    }
                    if(!response || response.encid !== requestedEncid){
                        // The encounter that came back is not the encounter that
                        // was requested. Same policy as a rejection.
                        this.encLoadFailed();
                        return;
                    }
                    // Everything the deep emToolACEP watcher sees before the
                    // next tick belongs to this hydration, not to the user.
                    this.acepHydrating = true;
                    this.activeEnc = response;
                    // Resolve this encounter's worksheet for its own facility
                    // and DOS. Fire and forget on purpose: the action never
                    // rejects, it reports through its own request state, and
                    // encounter hydration must not wait on the service.
                    this.$store.dispatch("resolveACEPToolForEncounter",response);

                    if(this.activeEnc.qa_notes && this.activeEnc.qa_notes[0]){
                        this.qanotein = this.activeEnc.qa_notes[0].note;
                    }else{
                        this.activeEnc.qa_notes = [{
                            note:"",
                            user: this.$store.getters.username,
                            time: new Date().getTime()
                        }];
                        this.qanotein = "";
                    }
                    
                    // The generation travels into the log fetch as well. This
                    // open is still current here, but getLogs() starts its own
                    // GET and can complete after a newer open has taken the
                    // editor, so the guard has to reach the writes it makes.
                    this.getLogs(response.encid,(status ? status : response.status),(response.qa_user ? true : false),generation);
                    
                    if(response.codes.em[0].tool){
                        if(this.$store.getters.facTools.indexOf('EM_TOOL_PRO_LT')!=-1){
                            this.emToolPro = response.codes.em[0].tool;
                        }else if(this.acepToolEnabled){
                            this.emToolACEP = response.codes.em[0].tool.selected;
                        }
                    }else{
                        if(this.$store.getters.facTools.indexOf('EM_TOOL_PRO_LT')!=-1){
                            this.emToolPro = {"history":"Problem-Focused","exam":"Problem-Focused","mdm":"Straightforward","time":"Less than 30 minutes"};
                            this.activeEnc.codes.em[0].tool = {"history":"Problem-Focused","exam":"Problem-Focused","mdm":"Straightforward","time":"Less than 30 minutes"};
                        }else if(this.acepToolEnabled){
                            this.emToolACEP = [];
                            this.activeEnc.codes.em[0].tool = {selected:[],note:""};
                        }
                        
                    }

                    if(this.$store.getters.facTools.indexOf('EM_TOOL_PRO_LT')!=-1){
                        if(!this.activeEnc.downcodes){
                            this.activeEnc.downcodes = [];
                        }
                    }

                    if(response.codes.em[1]){
                        this.secondEM = true;
                    }else{
                        this.secondEM = false;
                    };
                    // Released here, not at the end of the callback: this is
                    // the last statement that can queue an emToolACEP watcher,
                    // so nothing below can strand the guard by throwing. The
                    // watcher queued above runs in the scheduler flush that
                    // precedes this $nextTick, and registering it
                    // unconditionally means a hydration that assigned nothing
                    // still frees the flag.
                    this.$nextTick(() => {
                        this.acepHydrating = false;
                    });
                    this.activeDocs = [{
                        dockey:response.dockey,
                        name:response.dockey,
                        type:"pdf"
                    }];
                   history.pushState(null, "", location.href.split("?")[0] + "?encid=" + response.encid);
                    //this.$store.dispatch("updateEncPDF",response.dockey);
                    if(!readonly){
                        // if(this.activeEnc.status == "QA" && !this.qaEnc){
                        //     this.qaEnc = true;
                        //     this.openLastQA();
                        // }
                        this.activeEnc.status = "IN PROGRESS";
                        this.$store.dispatch("updateActiveEncId",response.encid);
                        this.saveInP('IN PROGRESS');
                    }else{
                        //this.$refs.encform.validate();
                        //this.forceFormValidate("encform");
                    }
                }).catch(() => {
                    // The GET had no rejection handling at all: an auth,
                    // network, parsing or server failure left the previous
                    // patient on screen under the row that was just clicked,
                    // with no indication that the open had failed.
                    if(generation !== this.encOpenGeneration){
                        return;
                    }
                    this.encLoadFailed();
                });
        },
        getLogs:function(encid,status,qaed,generation){
            this.getData(
                    "https://8zoc7gp928.execute-api.us-east-1.amazonaws.com/v2/byencounter/" + encid
                ).then((response) => {
                    // console.log("LOGS: " + response.length);
                    //// console.log(JSON.stringify(response[0]));
                    if(generation !== undefined && generation !== this.encOpenGeneration){
                        // The same race as the encounter GET, one hop out. This
                        // list is what openLastQA() picks the QA snapshot from
                        // and what the QA banner is raised on, so a superseded
                        // open that still wrote here would put one patient's
                        // audit trail and QA comparison over another patient's
                        // chart. The generation is optional on purpose: only the
                        // openRow() path supplies one, so a user-initiated call
                        // is never dropped.
                        return;
                    }
                    this.encLogs = response;
                    // The banner is NOT raised here. It used to be, one hop
                    // before the snapshot it describes: this branch set
                    // qaEnc = true and only then started openLastQA(), whose
                    // getLogDetail GET lands much later, so "banner up, snapshot
                    // empty" was a real state on every QA open. That state is a
                    // render-time TypeError, not merely an empty comparison —
                    // Phase 4.5 task 7 made only the ACEP picker label total
                    // against a sparse snapshot, which is why that one label
                    // survived it, while roughly thirty other comparison labels
                    // in this form still read activeQaEnc.codes.em[0]...,
                    // activeQaEnc.downcodes[dcind] and the like, and with an
                    // empty snapshot activeQaEnc.codes is undefined and .em
                    // throws. It was survivable only because it was transient:
                    // Vue 2 wraps _render in try/catch, logs the error and
                    // reuses the previous vnode, and the next render succeeds
                    // once the snapshot lands. Where the third hop never lands
                    // at all — the GET rejects, or no log has status QA — the
                    // form would stay frozen on the stale vnode.
                    //
                    // So qaEnc now rises in getLogDetail's forQA branch, beside
                    // the activeQaEnc write, making "the QA banner is never up
                    // without a QA snapshot" true by construction rather than by
                    // render-error recovery. The consequence is that the QA
                    // comparison labels appear when the snapshot lands instead
                    // of one render earlier with nothing to compare against —
                    // strictly better, since the earlier render was the crashing
                    // one, and it also removes the first-QA-open console error
                    // this form has always logged. The Complete branch's qa_diff
                    // decision is gated on the same flag, so it too now runs
                    // only when there is a real baseline to decide against
                    // instead of deep-comparing the chart to an empty object.
                    //
                    // The !this.qaEnc re-entry guards still do their job:
                    // openRow() clears qaEnc before this GET starts, so the flag
                    // is false here for a fresh open and true only when a
                    // snapshot for this encounter is already loaded.
                    if(!this.readonly && !this.qaEnc && status == "QA"){
                        this.openLastQA(generation);
                    }else if(this.readonly && qaed && !this.qaEnc && (status == "COMPLETE" || status == "EXPORT")){
                        this.openLastQA(generation);
                    }
                });
        },
        openLog(row){
            this.selectedLog = row;
            this.getLogDetail(row.dockey,false);
            this.logdetaildialog = true;
        },
        getProviderDetail:function(uuid){
            if(uuid){
                let provDet = this.$store.getters.Providers.find(x => x.uuid == uuid),out="";
                //// console.log(provDet.displayName + " (" + uuid + ")");
                if(provDet && provDet.displayName){
                    out = provDet.displayName + " (" + uuid + ")"
                }else{
                    out = uuid;
                }
                return out;
                
                // this.getData(
                //         "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/providers/" + this.facility + "/" + uuid
                //     ).then((response) => {
                //         //// console.log("LOGS: " + response.length);
                //         // console.log(response.displayName + " (" + uuid + ")");
                //         return response.displayName + " (" + uuid + ")";
                //     });
            }else{
                return "";
            }
        },
        getLogDetail:function(dockey,forQA,generation){
            this.getData(
                    "https://8zoc7gp928.execute-api.us-east-1.amazonaws.com/v2/encdetail/" + this.client + "/" + this.facility + "/" + dockey
                ).then((response) => {
                    //// console.log("LOGS: " + response.length);
                    //// console.log(JSON.stringify(response[0]));
                    if(generation !== undefined && generation !== this.encOpenGeneration){
                        // Third hop of the same open. Only the openRow() ->
                        // getLogs() -> openLastQA() chain supplies a generation,
                        // so this drops exactly the QA snapshot of a superseded
                        // open: activeQaEnc feeds every "QA versus current" label
                        // and the qa_diff decision, and one patient's snapshot
                        // beside another patient's chart is the same wrong-patient
                        // defect the encounter guard exists to stop. openLog()
                        // passes nothing, because the user asked for that log.
                        return;
                    }
                    if(forQA){
                        // One statement pair, deliberately: the snapshot and the
                        // banner that describes it rise together, so no render
                        // can ever see qaEnc true with activeQaEnc empty. Every
                        // "QA versus current" label reads into this object, and
                        // all but the ACEP one assume its shape, so raising the
                        // flag anywhere earlier is a thrown render rather than a
                        // blank comparison. Same shape as EnhancedEditor.
                        this.activeQaEnc = response;
                        this.qaEnc = true;
                    }else{
                        this.encLogDetail = response;
                    }
                });
        },
        rowClick: function (row) { 
            //// console.log(JSON.stringify(row));  
            row.status = "IN PROGRESS";
            this.getData(
                    "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.facility + "/" + row.encid
                ).then((response) => {
                    //// console.log(response);
                    response.status = "IN PROGRESS";
                    this.activeEnc = response;
                    
                    if(this.activeEnc.qa_notes && this.activeEnc.qa_notes[0]){
                        this.qanotein = this.activeEnc.qa_notes[0].note;
                    }else{
                        this.activeEnc.qa_notes = [{
                            note:"",
                            user: this.$store.getters.username,
                            time: new Date().getTime()
                        }];
                        this.qanotein = "";
                    }

                    if(response.codes.em[1]){
                        this.secondEM = true;
                    }else{
                        this.secondEM = false;
                    };
                    this.$store.dispatch("updateActiveEncId",response.encid); 
                    this.activeDocs = [{
                        dockey:response.dockey,
                        name:response.dockey,
                        type:"pdf"
                    }];
                    //this.$store.dispatch("updateEncPDF",response.dockey);
                    this.saveInP('IN PROGRESS');
                });
            
            //let selectState = (row.isSelected) ? false : true;
            //row.select(selectState);
        },
        shallowEqual(object1,object2,keys){
            for(let k=0; k<keys.length; k++){
                if(object1[keys[k]] != object2[keys[k]]){
                    return false;
                }
            }
            return true;
        },
        deepEqual(object1, object2) {
            const keys1 = Object.keys(object1).sort();
            const keys2 = Object.keys(object2).sort();

            //// console.log("DEEP EQUAL CHECK: " + keys1.length + " | " + keys2.length);
            // // console.log(JSON.stringify(object1));
            // // console.log(JSON.stringify(object2));
            //// console.log(JSON.stringify(keys1));
            //// console.log(JSON.stringify(keys2));

            if (keys1.length !== keys2.length) {
                //// console.log("RET: FALSE 1");
                return false;
            }

            for (const key of keys1) {
                const val1 = object1[key];
                const val2 = object2[key];
                const areObjects = this.isObject(val1) && this.isObject(val2);
                if (
                areObjects && !this.deepEqual(val1, val2) ||
                !areObjects && val1 !== val2
                ) {
                //// console.log(JSON.stringify(val1));
                //// console.log(JSON.stringify(val2));
                //// console.log("RET: FALSE 2");
                return false;
                }
            }
            //// console.log("RET: TRUE");
            return true;
        },
        isObject(object) {
            return object != null && typeof object === 'object';
        },
        async postData(url = "", data = {}) {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data), // body data type must match "Content-Type" header
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        async getData(url = "") {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
      // ageTator(dobin){
      //   let out;
      //   if(dobin && dobin.includes("/")){
      //     let dobarr = dobin.split("/"),
      //       dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
      //       diff = Date.now() - dob.getTime(),
      //       age = new Date(diff);
      //     out = Math.abs(age.getUTCFullYear() - 1970);
      //   }else{
      //     out = null;
      //   }
      //   return out
      // }
      ageTator(value, data, type, params, component){
        let out;
        if(data && data.dob.includes("/")){
          let dobarr = data.dob.split("/"),
            dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
            diff = Date.now() - dob.getTime(),
            age = new Date(diff);
          out = Math.abs(age.getUTCFullYear() - 1970);
        }else{
          out = null;
        }
        return out
      }
    }
  };
</script>

<style>
.acfix .v-select__selections{
    overflow-y:scroll !important;
    margin-top: 10px;
    z-index:0;
    height: 60px;
}

.demofields{
    border-radius:0;
    font-size: 12px;
    height: 50px;
}

.demofields25{
    border-radius:0;
    font-size: 12px;
    height: 25px;
}

.textareafix textarea{
    line-height: 16px !important; 
    padding: 5px 0px !important;
}

.textareafix2 .v-input__control{
    height:50px !important;
}

.textareafix4 .v-input__control{
    height:100px !important;
}

.error--text{
    font-style: italic !important;
}

.activeLabelOver label:first-of-type{
    transform: translateY(-16px) scale(0.75) !important;
}

.nextDay label{
    font-size: 13px;
    line-height: 13px !important;
    margin-left: -5px;
}

.enctable table {
    table-layout: fixed;
}

.encLogTable{
    border:thin solid rgba(255, 255, 255, 0.12);
}

.encLogTable .v-data-footer{
    height: 50px !important;
}

.encLogTable th + th{
    border-left:thin solid rgba(255, 255, 255, 0.12);
}

.encLogTable td + td{
    border-left:thin solid rgba(255, 255, 255, 0.12);
}

.encLogTableLt{
    border:thin solid rgba(0, 0, 0, 0.12);
}

.encLogTableLt .v-data-footer{
    height: 50px !important;
}

.encLogTableLt th + th{
    border-left:thin solid rgba(0, 0, 0, 0.12);
}

.encLogTableLt td + td{
    border-left:thin solid rgba(0, 0, 0, 0.12);
}

.theme--dark.v-input--is-disabled{
    color: rgba(255, 255, 255, 0.8) !important;
}

.theme--dark.v-label--is-disabled{
    color:rgba(255, 255, 255, 0.8) !important;
}

.theme--dark.v-input--is-disabled input{
    color: rgba(255, 255, 255, 0.8) !important;
}

.theme--light.v-input--is-disabled{
    color: rgba(0, 0, 0, 0.8) !important;
}

.theme--light.v-label--is-disabled{
    color:rgba(0, 0, 0, 0.8) !important;
    background-color: white !important;
}

.theme--light.v-label--active{
    color:rgba(0, 0, 0, 0.8) !important;
    background-color: white !important;
}

.theme--light.v-input--is-disabled input{
    color: rgba(0, 0, 0, 0.8) !important;
}

tr.v-data-table__selected {
    background: limegreen !important;
  }

.v-data-footer{
    height: 30px !important;
    padding: 0px !important;
    margin: 0px !important;
}
.v-data-footer__select{
    height: 30px !important;
}
.v-card__title{
    padding: 5px !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
</style>